import { ChangeDetectorRef, Component, ElementRef, Inject, Input, OnInit, TemplateRef, ViewChild, OnDestroy } from '@angular/core';
import { ActivatedRoute, Router, NavigationEnd } from '@angular/router';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';
import { DatePipe, Location } from '@angular/common';
import { FormBuilder, FormControl, FormGroup, UntypedFormControl, Validators } from '@angular/forms';
import { MatSnackBar } from '@angular/material/snack-bar';
import { LeadActivityService } from 'src/app/services/lead-activity.service';
import { LeadStatusService } from 'src/app/services/lead-status.service';
import { LeadService } from 'src/app/services/lead.service';
import { CrmsettingsService } from 'src/app/services/crmsettings.service';
import { CrmNoteService } from 'src/app/services/crm-note.service';
import { ConversationPopupComponent } from 'src/app/shared/conversation-popup/conversation-popup.component';
import { TransferLeadComponent } from 'src/app/shared/transfer-lead/transfer-lead.component';
import { Constant } from 'src/app/constant/constant';
import { CrmNoteComponent } from 'src/app/shared/crm-note/crm-note.component';
import { CallListComponent } from 'src/app/shared/call-list/call-list.component';
import { takeUntil, filter } from 'rxjs/operators';
import { Subject } from 'rxjs';
import { SearchBuilderComponent } from 'src/app/shared/search-builder/search-builder.component';
import { environment } from 'src/environments/environment';
import { ProductService } from 'src/app/services/product.service';
import { CategoriesService } from 'src/app/services/categories.service';
import { downloads, ResourceAccess } from 'src/app/shared/utils/calsoft-validators';
import { DynamicFormLabelService } from 'src/app/services/dynamic-form-label.service';
import icPhone from '@iconify/icons-ic/twotone-phone';
import icWhatsapp from '@iconify/icons-mdi/whatsapp';
import { ConfigService } from 'src/app/services/config.service';
import { LoaderService } from 'src/app/services/loader.service';
import { EcryptServiceService } from 'src/app/core/auth/EcryptionService/ecrypt-service.service';
import { EmailSendService } from 'src/app/services/email-send.service';
import { MailBoxService } from 'src/app/services/mail-box.service';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
import { PageEvent } from '@angular/material/paginator';
import { LeadActivityListService } from 'src/app/services/lead-activity-list.service';
import { SimpleDynamicFormComponent } from 'src/app/shared/simple-form/simple-dynamic-form/simple-dynamic-form.component';
import { L } from '@angular/cdk/keycodes';
import { TemplateServiceService } from 'src/app/services/template-service.service';
import { EmailPopupComponentComponent } from '../lead-detail/email-popup-component/email-popup-component.component';
import { EditprofileComponent } from '../lead-detail/editprofile/editprofile.component';
import { DealsService } from 'src/app/services/deals.service';
import { GoogleCalendarServiceAccountService } from 'src/app/services/google-calendar-service-account.service';
import { CommonService } from 'src/app/services/common.service';
import { ProfileEditorDialogComponent } from '../lead-detail/profile-editor-dialog/profile-editor-dialog.component';
import { FileUploadPopupComponent } from '../../file-upload-popup/file-upload-popup.component';
import { AddMeetingComponent } from '../../companies/add-meeting/add-meeting.component';
import { DownloadImageService } from 'src/app/services/download-image.service';
import { FieldEditDialogComponent } from '../lead-detail/field-edit-dialog/field-edit-dialog.component';
import { ActivityService } from 'src/app/services/activity.service';
import { MatTableDataSource } from '@angular/material/table';
import { FieldDesignerService } from 'src/app/services/field-designer.service';
import { TwilloDialerComponent } from '../../phone-dialer/twillo-dialer/twillo-dialer.component';

export interface PipelineStep {
  stage: string;
  name: string;
  status: any;
}


@Component({
  selector: 'calsoft-lead-detail-panel',
  templateUrl: './lead-detail-panel.component.html',
  styleUrls: ['./lead-detail-panel.component.scss']
})
export class LeadDetailPanelComponent implements OnDestroy {


  url = '';
  sanitizedUrl = '';

  basePath = environment.commonImageApi + '/profile/'
  cid: any;

  icPhone = icPhone;
  icWhatsapp = icWhatsapp;
  whatsapplogs = "e124595e-81d7-4e4c-81df-e3e1a6f2263b";
  tabs = [
    { name: 'Overview', icon: 'grid_view' },
    { name: 'Contact details', icon: 'person' },
    { name: 'My Views', icon: 'user_attributes' },
    // { name: 'Conversations', icon: 'chat' },
    { name: 'Activities', icon: 'task_alt' },
    { name: 'Company', icon: 'domain' },
    { name: 'Deals', icon: 'monetization_on' },
    // { name: 'Freddy AI insights', icon: 'psychology' },
    { name: 'Files', icon: 'folder' }
  ];


  isCollapsed = false;
  hoveredField: any = null;
  selectedField: any = null;
  editOptions = ['Edit Text', 'Change Value', 'Remove'];
  dynamicFields = []
  @Input() groupBy: any = 'activityType';
  showEditIcon = false;
  isEditMenuOpen = false;
  name = 'Pavithran Rajendran';
  search: string;
  calllist: any;
  dialerType: any;
  updateType: string = null;
  pageSize: any;
  totalSize: any;
  leadActivityListFinal: Object;
  isEmpty: any;
  onScrollValue: boolean = true;
  displayOwner: boolean = false;
  leadLoaded: boolean = false;


  //for email
  emails: any[] = [];
  selectedEmail: any = null;
  currentMailBox: string = 'INBOX';
  activeTabInner: string = 'activity';
  pageIndex = 0;
  pageSizeEmail = 10;
  totalEmails = 0;
  isLoading = false;
  enableDynamicTabs: any;
  leadActivityDropDowns: Object;
  leadTabs: any;
  emailObject: any;
  emailVisble: boolean = false;
  defaultForms: any = 0;
  baseUrl: any;

  public newserverpath: string = '';
  isCollapsedtwo: boolean;
  taskCounts = {
    all: 0,
    upcoming: 0,
    overdue: 0,
    completed: 0
  };

  allIds: any;
  currentIndex: any;
  noOfDeals: any;
  noOfMeetings: any;
  dealSetId: any;
  defaultSet: any;
  defaultSetType: any;
  relatedCompanyId: any;
  meetingType: any = 1;
  notesType: any;


  openDeals = [
    { name: 'Widgetz.io (sample)', value: 5600, status: 'New', closes: 'Closes in Oct' }
  ];


  isPopupVisible = false;
  isEditing = false;

  // Holds the data for the note being created or edited in the popup
  currentNoteData: Partial<any> = { notes: '' };

  // Set to keep track of which notes are expanded
  private expandedNotes = new Set<number>();


  loading: boolean = false;




  selectedTab = 'activities';

  // Sample data for each tab
  tabData: { [key: string]: string } = {
    activities: 'This is the Activities content.',
    notes: 'This is the Notes content.',
    calls: 'This is the Calls content.',
    files: 'This is the Files content.',
    email: 'This is the Email content.'
  };

  leadDetailPageType: any;
  PopupadataLeadEntity: any;
  lifeCycleStage: any;
  previousValue: any;


  selectTab(tabId: string): void {
    this.selectedTab = tabId;
  }

  leadActivityList: any = [];

  init: boolean = false;

  LeadDetailsObject: any;
  leadId: any;

  public editMode = false;
  leadStatusList: any;

  public selectedLeadStatus: string;
  text: string = "Save";

  leadAge: string;
  textAccount: string;
  leadPropertiesName: any;
  leadAdditionalPropertiesName: any;
  leadCommonPropertiesName: any;
  leadNoteDisplay: any;
  leadAdditionalPropertiesDisplay: any;
  leadCommonPropertiesDisplay: any;
  leadPropertiesDisplay: any;
  additionalSpec: any;
  filterList: any;

  noteList: any = [];
  usedInSite: any;
  jsonRecieved: any;
  id: any;
  activityId: any;
  textCall: string;
  ownerId: any;
  type1: boolean = false;
  additionalSpecList: any = [];
  type2: boolean = false;
  valuesList: any = [];
  type3: boolean = false;
  customList: any = [];
  crmType: any;
  dialerShow: boolean;
  customField1: any;
  additionalData: boolean = false;
  additionalAttributeName: any;
  additionalAttributeEnable: any = 0;
  enableInvoiceInLead: any = 0;
  newType: number = 1;
  customField10: any;
  customField9: any;
  finalValueForm: any = {};
  patchValues: any;
  formInit: boolean = false;
  sameLeadName: boolean;
  emailValue: any;
  phoneValue: any;
  whatsAppCustomUrl: any;
  whatAppUrl: any;
  storeName: any;
  data: any;
  GridType: any;

  defaultForm: boolean = false;
  activeViewNew: 'Original' | 'basic' = 'basic';

  constructor(
    public dialogRef: MatDialogRef<LeadDetailPanelComponent>,
    @Inject(MAT_DIALOG_DATA) PopupadataLeadEntity,
    private route: ActivatedRoute,
    private sanitizer: DomSanitizer,
    private mailboxService: MailBoxService,
    private leadActivityListSerive: LeadActivityListService,
    private leadActivityService: LeadActivityService,
    private ecryptService: EcryptServiceService,
    private dialog: MatDialog,
    private leadStatusService: LeadStatusService,
    private fb: FormBuilder,
    private snackBar: MatSnackBar,
    private leadService: LeadService,
    private crmsettingsService: CrmsettingsService,
    private crmNoteService: CrmNoteService,
    private productService: ProductService,
    public location: Location,
    private router: Router,
    private dynamicFormLabelService: DynamicFormLabelService,
    private changeDetector: ChangeDetectorRef,
    private loaderService: LoaderService,
    private emailSendService: EmailSendService,
    private mailBox: MailBoxService,
    private templateService: TemplateServiceService,
    private dealsService: DealsService,
    private googleCalendarServiceAccountService: GoogleCalendarServiceAccountService,
    private commonService: CommonService,
    private downloadImageService: DownloadImageService,
    private activityService: ActivityService,
    private fieldDesignerService: FieldDesignerService,
    private categoriesService: CategoriesService,
  ) {
    this.url = this.router.url || '';
    this.sanitizedUrl = this.sanitizeUrl(this.url);
    this.router.events.pipe(filter((e: any) => e instanceof NavigationEnd), takeUntil(this._onDestroy)).subscribe(() => {
      this.url = this.router.url || '';
      this.sanitizedUrl = this.sanitizeUrl(this.url);
    });

    this.PopupadataLeadEntity = PopupadataLeadEntity;
    this.url = this.router.url || '';
    this.router.events
      .pipe(filter((e: any) => e instanceof NavigationEnd), takeUntil(this._onDestroy))
      .subscribe(() => { this.url = this.router.url || ''; });

  }




  public serverPathEmail = environment.commonImageApi + 'image/';

  public serverPath = environment.commonImageApi + '/courseAudio/';

  public serverPathImage = environment.commonImageApi + 'courseImage/';

  public serverPathPdf = environment.commonImageApi + 'coursepdf/';

  public serverPathVedio = environment.commonImageApi + '/courseVideo/';

  public serverPathNotes = environment.commonImageApi + 'crmFiles/';

  modifiedname: any;

  textSend: string;

  isExpandedTwo = false;

  userId: any;

  companyId: any;

  uploadedImageUrl: string;

  totalActivity: any;

  total: number;
  leadActivityListUpcoming: any = [];
  leadActivityListFinalUpcoming: any = [];
  leadActivityListCompleted: any = [];
  leadActivityListFinalCompleted: any = [];
  leadActivityListDue: any = [];
  leadActivityListDueFinal: any = [];
  totalCompleted: any = 0;
  totalOverdue: any = 0;
  totalUpcoming: any = 0;
  onScrollValueUpcoming: any = false;
  pagetwoUpComing = 0;

  onScrollValueDue: any = false;
  pagetwoDue = 0;
  totalActivityUpComing: any = 0;
  pagetwoUpcoming: any;
  totalSizeUpcoming: any;
  taskType: any;



  ngOnInit(): void {

    if (this.url.includes('deals') || this.url.includes('type=deal')) {
      this.tabs = this.tabs.filter(tab => tab.name !== 'Contact details' && tab.name !== 'My Views' && tab.name !== 'Company' && tab.name !== 'Files');
    }

    this.data = this.PopupadataLeadEntity.data;


    this.checkMobile();
    window.addEventListener('resize', this.checkMobile.bind(this))

    //for email

    let val = parseInt(localStorage.getItem(Constant.SU))

    if (isNaN(val)) {
      val = 0;
    }

    if (val > 0) {

      this.displayOwner = true;

    } else {
      this.displayOwner = false;
    }

    let values = localStorage.getItem(Constant.enterPriseKey);

    this.cid = "&cid=" + values

    this.dynamicFields = [
      { icon: 'star_border', property: 'name', formControlName: 'Name', placeholder: 'Name', editMode: false },
      { icon: 'mail', property: 'email', formControlName: 'Email', placeholder: 'Email', editMode: false },
      { icon: 'call', property: 'phoneNumber', formControlName: 'PhoneNumber', placeholder: 'Phone Number', editMode: false },
      { icon: 'location_on', property: 'Address', formControlName: 'Address', placeholder: 'Address', editMode: false },
      { icon: 'person_outline', property: 'CrName', formControlName: 'CrName', placeholder: 'Cr Name', editMode: false },
      { icon: 'assignment', property: 'CrNo', formControlName: 'CrNo', placeholder: 'Cr No', editMode: false }
    ];

    this.modifiedname = localStorage.getItem('authenticaterUserEmail') || '';
    this.selectedTab = "activities";
    this.leadId = this.PopupadataLeadEntity?.currentId || this.PopupadataLeadEntity?.data?.entityId || this.PopupadataLeadEntity?.data?.id;
    this.allIds = this.PopupadataLeadEntity?.allIds || [];
    if (Array.isArray(this.allIds) && this.leadId != null) {
      this.currentIndex = this.allIds.findIndex((id: any) => String(id) === String(this.leadId));
      if (this.currentIndex === -1) {
        this.currentIndex = 0;
      }
    } else {
      this.currentIndex = 0;
    }

    this.selectTab(this.selectedTab);
    this.getAllLeadDetailsInitally();
    this.getAllLeadDetails(this.leadId);
    this.getAllManageContactFields();
    this.createFormGroup();
    this.textAccount = 'OK';

    this.textCall = 'Call'

    this.textSend = "Send";

    this.dialerShow = false;

    this.getEmailTemplateMessageList();

    this.EmailTemplateMessageYFilter();

    this.userId = localStorage.getItem('userId');
    this.companyId = localStorage.getItem('storeName');
    this.isCollapsedtwo = true;
    this.getCount();
    setTimeout(() => {
      this.loadingSpinner = false;
    }, 3000);
    this.getResource();


    this.firstFormGroup.get("twitter").setValue(this.LeadDetailsObject.twitter || '');

    this.firstFormGroup.get("facebook").setValue(this.LeadDetailsObject.facebook || '');

    this.firstFormGroup.get("linkedIn").setValue(this.LeadDetailsObject.linkedIn || '');



  }
  getResource() {
    this.commonService
      .getAllAccessForResource(ResourceAccess.LEAD)
      .subscribe((data: any) => {

        if (!data.read) {
          this.router.navigate(['/unauthorized']);
        } else {

          this.resourcePrivilege = data;



        }
      });
  }
  // when clicking next
  goNext() {
    if (this.allIds?.length && this.currentIndex < this.allIds.length - 1) {
      this.currentIndex++;
      this.leadId = this.allIds[this.currentIndex];
      this.refreshLead();
    }
  }

  // when clicking previous
  goPrevious() {
    if (this.allIds?.length && this.currentIndex > 0) {
      this.currentIndex--;
      this.leadId = this.allIds[this.currentIndex];
      this.refreshLead();
    }
  }
  refreshLead() {
    this.selectTab(this.selectedTab);
    this.getAllLeadDetails(this.leadId);
  }


  checkMobile() {
    this.isMobileView = window.innerWidth <= 768;
  }

  backToList() {
    this.emailVisble = false;
  }


  taskButtonEnable: any = true;

  leadActionsbuttonEnable: any = true;

  sendEmailbutttonEnable: any = true;

  sendEmailTemplateEnable: any = true;

  builderSearchPopupEnable: any = false;

  invoicebuttonEnable: any = true;

  quotationbuttonEnable: any = true;

  taskButtonName: any = 'Task'

  leadActionsbutton: any = 'Lead Actions'

  sendEmailbuttton: any = 'Send Email'

  sendEmailTemplate: any = 'Email Template'

  builderSearchPopup: any = 'Search'

  invoicebutton: any = 'Invoice'

  quotationbutton: any = 'Quotation'

  getAllLeadActivityList() {
    this.leadActivityListSerive.getAllLeadActivityListDropDown().subscribe(
      res => {
        this.leadActivityDropDowns = res;
        this.leadTabs = this.leadActivityDropDowns;


        let index = this.leadTabs.findIndex(x => x.name === 'activity');

        if (index > -1) {
          this.getAllLeadActivity(this.leadId);
          this.getAllLeadActivityTasks(this.leadId);
        } else {
          index = this.leadTabs.findIndex(x => x.name === 'tasks');
          if (index > -1) {
            this.getAllLeadActivityTasks(this.leadId);
          }
        }

        index = this.leadTabs.findIndex(x => x.name === 'notes');
        if (index > -1) {
          this.getLeadNote(this.leadId);
        }

        index = this.leadTabs.findIndex(x => x.name === 'calls');
        if (index > -1) {
          this.getcallList();
        }

        index = this.leadTabs.findIndex(x => x.name === 'email');
        if (index > -1) {
          this.getAllEmailSend(this.leadId);
          this.loadEmails({ value: 'INBOX' });
        }

        index = this.leadTabs.findIndex(x => x.name === 'taskbutton');
        if (index < 0) {
          this.taskButtonEnable = false;
        } else {
          this.taskButtonName = this.leadTabs[index]['label'];
          this.leadTabs.splice(index, 1);
        }

        index = this.leadTabs.findIndex(x => x.name === 'leadActionsbutton');
        if (index < 0) {
          this.leadActionsbuttonEnable = false;
        } else {
          this.leadActionsbutton = this.leadTabs[index]['label'];
          this.leadTabs.splice(index, 1);
        }

        index = this.leadTabs.findIndex(x => x.name === 'sendEmailbuttton');
        if (index < 0) {
          this.sendEmailbutttonEnable = false;
        } else {
          this.sendEmailbuttton = this.leadTabs[index]['label'];
          this.leadTabs.splice(index, 1);
        }

        index = this.leadTabs.findIndex(x => x.name === 'sendEmailTemplate');
        if (index < 0) {
          this.sendEmailTemplateEnable = false;
        } else {
          this.sendEmailTemplate = this.leadTabs[index]['label'];
          this.leadTabs.splice(index, 1);
        }


        index = this.leadTabs.findIndex(x => x.name === 'builderSearchPopup');
        if (index < 0) {
          this.builderSearchPopupEnable = false;
        } else {
          this.builderSearchPopupEnable = true;
          this.builderSearchPopup = this.leadTabs[index]['label'];
          this.leadTabs.splice(index, 1);
        }

        index = this.leadTabs.findIndex(x => x.name === 'invoicebutton');
        if (index < 0) {
          this.invoicebuttonEnable = false;
        } else {
          this.invoicebutton = this.leadTabs[index]['label'];
          this.leadTabs.splice(index, 1);
        }

        index = this.leadTabs.findIndex(x => x.name === 'quotationbutton');
        if (index < 0) {
          this.quotationbuttonEnable = false;
        } else {
          this.quotationbutton = this.leadTabs[index]['label'];
          this.leadTabs.splice(index, 1);
        }

      },
      error => {
      })
  }

  searchText: string = '';

  icons = [
    { icon: 'note', label: 'Create a Note', name: 'Notes' },
    { icon: 'email', label: 'Create an Email', name: 'Email' },
    { icon: 'call', label: 'Make a Phone call', name: 'Call' },
    { icon: 'task', label: 'Create a task', name: 'Task' },
    { icon: 'event', label: 'Shedule a Meeting', name: 'Event' },
    { icon: 'more_vert', label: 'More', name: 'More' }
  ];

  menuItems = ['Option 1', 'Option 2', 'Option 3', 'Option 4'];
  filteredMenuItems() {
    return this.menuItems.filter(item =>
      item.toLowerCase().includes(this.searchText.toLowerCase())
    );
  }

  onMenuItemClick(item: string) {

  }

  showDetails = true;
  toggleDetails() {
    this.showDetails = !this.showDetails;
  }
  openCallDialog() { }

  closeDialog() {
    this.dialog.closeAll();
  }




  getConfigData() {
    const encryptedData = localStorage.getItem('configSettingsData');
    if (encryptedData) {
      try {
        const decrypted = this.ecryptService.decryptionAES(encryptedData);
        const data = JSON.parse(decrypted);

        this.baseUrl = data['baseUrl'];

        this.newserverpath = this.baseUrl + '/ecom-gateway/ecom-svc-core-1.0-SNAPSHOT/api/core/download?fileName=image/';
      }
      catch (error) {

      }
    }
  }

  templateDisplayed: any;

  enableLocation: any;
  enableCallNotes: any;
  activityHistoryType: any = 0;
  webMobileCallEnable: any = 0;
  manageFieldCustomization: any = 0;
  enableSequence: boolean = false
  whatAppchatType: any;
  encryptPhone: any;
  encryptEmail: any;

  getAllCrmData() {

    const encryptedData = localStorage.getItem('crmSettingsData');
    if (encryptedData) {
      try {
        const decrypted = this.ecryptService.decryptionAES(encryptedData);
        const data = JSON.parse(decrypted);

        if (data != null) {

          if (data['leadDetailPageType'] != undefined) {
            this.leadDetailPageType = data['leadDetailPageType'];
          } else {
            this.leadDetailPageType = 0;
          }

          this.storeName = data['storeName'];

          this.leadPropertiesName = data['leadPropertiesName'];
          this.leadAdditionalPropertiesName = data['leadAdditionalPropertiesName'];
          this.leadCommonPropertiesName = data['leadCommonPropertiesName'];
          this.leadNoteDisplay = data['leadNoteDisplay'];
          this.leadAdditionalPropertiesDisplay = data['leadAdditionalPropertiesDisplay'];
          this.leadCommonPropertiesDisplay = data['leadCommonPropertiesDisplay'];
          this.leadPropertiesDisplay = data['leadPropertiesDisplay'];
          this.crmType = data['crmType'];
          this.additionalAttributeName = data['additionalAttributeName'];
          this.additionalAttributeEnable = data['additionalAttributeEnable'];
          this.enableInvoiceInLead = data['enableInvoiceInLead'];
          this.whatsAppCustomUrl = data['whatsAppCustomUrl'];
          this.whatAppUrl = data['whatAppUrl'];
          this.templateDisplayed = data['templateDisplayed'];
          this.dialerType = data['dialerType'];
          this.defaultSet = data['defaultSet'];
          this.defaultSetType = data['defaultSetType'];
          this.dealSetId = data['defaultDealsSet'];
          this.taskType = data['taskType'] || 1;
          this.notesType = data['notesType'];
          this.activityHistoryType = data['activityHistoryType'];

          if (data['webMobileCallEnable'] != undefined) {
            this.webMobileCallEnable = data['webMobileCallEnable'];
          } else {
            this.webMobileCallEnable = 0;
          }

          if (data['manageFieldCustomization'] != undefined) {
            this.manageFieldCustomization = data['manageFieldCustomization'];
          } else {
            this.manageFieldCustomization = 0;
          }

          this.enableSequence = data['enableSequences'] == 1 ? true : false;

          if (this.enableSequence) {

            let index = this.tabs.findIndex(x => x.name === 'Sequences');


            if (index == -1) {

              let object = { name: 'Sequences', icon: 'schedule' };

              this.tabs.push(object);

            }

          }

          this.whatAppchatType = data['whatsappType'] || 1;

          let value = localStorage.getItem(Constant.Sup);

          if (value != undefined) {

            if (value == 'salesUser') {


              this.encryptPhone = data['encryptedPhoneNumber'] == undefined ? 0 : data['encryptedPhoneNumber'];

              this.encryptEmail = data['encryptedEmailId'] == undefined ? 0 : data['encryptedPhoneNumber'];

            } else {
              this.encryptPhone = 0;
              this.encryptEmail = 0;
            }

          } else {
            this.encryptPhone = 0;
            this.encryptEmail = 0;
          }


          this.taskType = data['taskType'] || 1;

          // if (this.dialerType == 7) {
          //   this.initDialer();
          // }

          this.enableDynamicTabs = data['defaultLeadDetailTab'],

            this.defaultForms = data['defaultForms']

          if (data != null) {

            this.enableLocation = data['enableLocation'];

          } else {
            this.enableLocation = 0;
          }

          if (data != null) {

            this.enableCallNotes = data['enableCallNotes'];

          } else {
            this.enableCallNotes = 0;
          }

          if (this.leadDetailPageType == 5) {
            this.getAllLeadActivityUpcoming();
            this.getAllLeadActivityDue();
            this.getAllLeadActivityCompleted();

          }

          this.enableDynamicTabs = data['defaultLeadDetailTab'],

            this.defaultForms = data['defaultForms']

          if (data != null) {

            this.enableLocation = data['enableLocation'];

          } else {
            this.enableLocation = 0;
          }


          localStorage.setItem(Constant.LEAD_POPUP, data['enableInCallNotification']);

          if (this.enableDynamicTabs == 1) {
            this.getAllLeadActivityList();
          }
          else {

            this.getcallList();
            this.getLeadNote(this.leadId);
            this.getAllEmailSend(this.leadId);
            this.getConfigData();
            this.typeYFilter();
            this.getLeadDropDownList();

            this.getAllLeadActivity(this.leadId)

            this.leadTabs = [
              { label: 'Activity History', name: 'activity' },
              { label: 'Lead Detail', name: 'leadDetail' },
              { label: 'Tasks', name: 'tasks' },
              { label: 'Email', name: 'email' },
              { label: 'Chats', name: 'chats' },
              { label: 'Notes', name: 'notes' },
              { label: 'Original Lead Format', name: 'originalLead' },
              { label: 'Documents', name: 'documents' },
              { label: 'Payment', name: 'payment' },
              { label: 'Calendar', name: 'calendar' },
              { label: 'Deals', name: 'deals' },
              { label: 'Calls', name: 'calls' },
            ];

          }

        } else {

          this.notesType = 0;
          this.leadDetailPageType = 0;

        }

      } catch (error) {

      }
    }
  }


  calculateLeadAge(): void {
    const createdDate = new Date(this.LeadDetailsObject.createdDate);

    const currentDate = new Date();
    const timeDiff = Math.abs(currentDate.getTime() - createdDate.getTime());
    const days = Math.floor(timeDiff / (1000 * 3600 * 24));


    if (days === 0) {
      this.leadAge = `${days} Days`;
    } else {
      this.leadAge = `${days} Day${days !== 1 ? 's' : ''} Ago`;
    }


  }


  firstFormGroup: FormGroup;


  createFormGroup() {
    this.firstFormGroup = this.fb.group({
      CallDuration: [''],
      Country: [''],
      CreatedBy: [''],
      Description: [''],
      DoNotCall: [''],
      DoNotEmail: [''],
      Email: [''],
      LeadSource: [''],
      LeadStatus: [''],
      Name: [''],
      Notes: [''],
      Owner: [''],
      PhoneNumber: [''],
      ReceiverMobile: [''],
      Address: [''],
      CrNo: [''],
      CrName: [''],
      linkedIn: [''],
      facebook: [''],
      twitter: [''],
    });
  }


  editformGroup(leadset: any) {
    this.emailValue = leadset.email;
    this.phoneValue = leadset.phoneNumber;
    this.firstFormGroup = this.fb.group({
      CallDuration: leadset.callDuration,
      Country: leadset.Country,
      CreatedBy: leadset.createdBy,
      Description: leadset.description,
      DoNotCall: leadset.doNotCall,
      DoNotEmail: leadset.doNotEmail,
      Email: leadset.email,
      LeadSource: leadset.sourceId,
      LeadStatus: leadset.statusId,
      Name: leadset.name,
      Notes: leadset.notes,
      Owner: leadset.Owner,
      PhoneNumber: leadset.phoneNumber,
      ReceiverMobile: leadset.ReceiverMobile,
      statusName: leadset.statusName,
      sourceName: leadset.sourceName,
      statusReason: leadset.statusReason,
      Address: leadset.address,
      CrNo: leadset.CrNo,
      CrName: leadset.CrName,
      linkedIn: '',
      facebook: '',
      twitter: '',
    })

    let finalObject = { ... this.customField9, ... this.customField10, ... this.firstFormGroup.value };


    this.patchValues = finalObject;


    if (this.defaultForms != null) {

      this.getDefaultForm(this.defaultForms);

    } else {

      this.defaultForm = false;

    }
    this.firstFormGroup.get("twitter").setValue(this.LeadDetailsObject.twitter || '');

    this.firstFormGroup.get("facebook").setValue(this.LeadDetailsObject.facebook || '');

    this.firstFormGroup.get("linkedIn").setValue(this.LeadDetailsObject.linkedIn || '');
    this.getLeadStatus();
    console.log(this.firstFormGroup);

  }


  mapLink: any;

  starsArray = Array(5).fill(0);
  filledStars = 0;
  updateStars() {
    const score = this.LeadDetailsObject?.score || 0;
    // Convert score (0-100) to stars (0-5)
    this.filledStars = Math.round((score / 100) * 5);
  }



  addLeadActivity(activityType: string, activityId, leadObject: any) {
    if (window.innerWidth > 768) {

      let dialogRef = this.dialog.open(ConversationPopupComponent, {
        width: '790px',
        disableClose: true,
        data: {
          "activityType": activityType,
          "type": "lead",
          "leadId": this.leadId,
          "activityId": activityId,
          "leadObject": leadObject,
          "templateDisplayed": this.templateDisplayed,
          "taskSaveType": 1
        }
      });

      dialogRef.disableClose = true;
      dialogRef.afterClosed().subscribe(result => {
        if (result['event'] == 'add') {
          this.onTaskUpdated();

        }



      });

    }
    else {
      let dialogRef = this.dialog.open(ConversationPopupComponent, {
        minWidth: '100vw', height: '100vh',
        data: {
          "activityType": activityType,
          "leadId": this.leadId,
          "activityId": activityId,
          "leadObject": leadObject,
          "type": "lead",
          "templateDisplayed": this.templateDisplayed,
          "taskSaveType": 1
        },
      });

      dialogRef.disableClose = true;
      dialogRef.afterClosed().subscribe(result => {
        if (result['event'] == 'add') {
          this.onTaskUpdated();

        }


      });
    }

  }

  addLeadActivityone(activityType: string, activityId, leadObject: any) {
    if (window.innerWidth > 768) {

      let dialogRef = this.dialog.open(ConversationPopupComponent, {
        width: '790px',
        disableClose: true,
        data: {
          "activityType": activityType,
          "type": "lead",
          "leadId": this.leadId,
          "activityId": activityId,
          "leadObject": leadObject,
          "taskSaveType": 1
        }
      });

      dialogRef.disableClose = true;
      dialogRef.afterClosed().subscribe(result => {
        if (result['event'] == 'add') {
          this.init = false;
          this.onTaskUpdated();

        }



      });

    }
    else {
      let dialogRef = this.dialog.open(ConversationPopupComponent, {
        minWidth: '100vw', height: '100vh',
        data: {
          "activityType": activityType,
          "leadId": this.leadId,
          "activityId": activityId,
          "leadObject": leadObject,
          "type": "lead",
          "taskSaveType": 1
        },
      });

      dialogRef.disableClose = true;
      dialogRef.afterClosed().subscribe(result => {
        if (result['event'] == 'add') {
          this.init = false;
          this.onTaskUpdated();

        }


      });
    }

  }



  transferLead() {
    if (window.innerWidth > 768) {

      let dialogRef = this.dialog.open(TransferLeadComponent, {
        width: '790px',
        disableClose: true,
        data: {
          "leadId": this.leadId,
          "ownerId": this.ownerId,
          "randomAssign": 0,
        }

      });

      dialogRef.disableClose = true;
      dialogRef.afterClosed().subscribe(result => {
        if (result && result['event'] == 'add') {
          this.router.navigate([`/lead`]);
        }
      });

    }
    else {
      let dialogRef = this.dialog.open(TransferLeadComponent, {
        minWidth: '100vw', height: '100vh',
        data: {
          "leadId": this.leadId,
          "ownerId": this.ownerId,
          "randomAssign": 0,
        }
      });

      dialogRef.disableClose = true;
      dialogRef.afterClosed().subscribe(result => {
        if (result && result['event'] == 'add') {
          this.router.navigate([`/lead`]);
        }

      });
    }
  }


  newSearch(LeadDetailsObject) {
    if (window.innerWidth > 768) {

      let dialogRef = this.dialog.open(SearchBuilderComponent, {
        width: '790px',
        disableClose: true,
        data: { data: LeadDetailsObject }
      });

      dialogRef.disableClose = true;
      dialogRef.afterClosed().subscribe(result => {
      });

    }
    else {
      let dialogRef = this.dialog.open(SearchBuilderComponent, {
        minWidth: '100vw', height: '100vh',
        data: { data: LeadDetailsObject }
      });

      dialogRef.disableClose = true;
      dialogRef.afterClosed().subscribe(result => {

      });
    }
  }

  editFormTwo(event: Event) {
    event.stopPropagation();

    this.formInit = false;
    let index = this.leadStatusList.findIndex(x => x.statusId === this.firstFormGroup.value.LeadStatus);
    if (index > -1) {
      this.patchValues.LeadStatus = this.firstFormGroup.value.LeadStatus
      this.getFormArray(this.leadStatusList[index].dynamicFormGroupId);
    }
    this.editMode = !this.editMode;


  }


  editForm() {

    this.formInit = false;
    let index = this.leadStatusList.findIndex(x => x.statusId === this.firstFormGroup.value.LeadStatus);
    if (index > -1) {
      this.patchValues.LeadStatus = this.firstFormGroup.value.LeadStatus
      this.getFormArray(this.leadStatusList[index].dynamicFormGroupId);
    }
    this.editMode = !this.editMode;


  }


  // save() {

  // }

  close() {
    this.editMode = false;
  }

  public page: any = Constant.PAGE;
  public size: any = Constant.SIZE;
  sortParam: any = 'statusId' + "," + Constant.Dsc;

  type: any = 0;
  currentStatusIndex: number = -1;
  getLeadStatus() {
    this.leadStatusService.LeadStatus(this.page, this.size, this.sortParam, this.type).subscribe(
      res => {
        this.leadStatusList = res['content'];

      },
      error => {
        console.log("Error fetching Lead Status", error);
      }
    );
  }

  checkLeadExist() {

    if ((this.emailValue != this.firstFormGroup.value.Email
      || this.phoneValue != this.firstFormGroup.value.PhoneNumber)) {
      let payload = {
        "Email": this.firstFormGroup.value.Email,
        "PhoneNumber": this.firstFormGroup.value.PhoneNumber,
        "entityId": this.leadId
      }
      this.leadService.leadAlreadyExist(payload).subscribe(
        (response) => {

          if (response['status_code'] == Constant.RESPONSE_SUCCESS) {
            this.sameLeadName = true;
            this.saveLead();
          }
          else {
            this.text = "Save"
            this.snackBar.open(response['data']['message'], '×',
              { panelClass: 'error', verticalPosition: 'bottom', duration: 500 });
          }
        },
        (err) => {
          this.text = "Save"
          this.sameLeadName = true
        });

      return this.sameLeadName;
    } else {

      this.saveLead()
    }
  }


  addMeeting() {
    let id = 0;
    this.dialog.closeAll();
    this.router.navigate([`/googleCalender/add-edit-google-calender/${id}/${this.leadId}`])
  }

  companyDetailPage(entityId) {
    this.dialog.closeAll();
    this.router.navigate([`companiesDetail/${entityId}`])
  }

  saveLead() {
    // this.text = "Processing"

    this.loaderService.show();
    let object = {
      "LeadStatus": this.firstFormGroup.value.LeadStatus,
      "entityId": this.leadId,
      "Name": this.firstFormGroup.value.Name,
      "Email": this.firstFormGroup.value.Email,
      "PhoneNumber": this.firstFormGroup.value.PhoneNumber,
      "Address": this.firstFormGroup.value.Address,
      "CrNo": this.firstFormGroup.value.CrNo,
      "CrName": this.firstFormGroup.value.CrName,
    }

    delete this.finalValueForm['LeadStatus'];
    let finalObject = { ...object, ...this.finalValueForm };

    const firstValue = Object.values(this.finalValueForm)[0];

    if (firstValue != undefined) {

      finalObject['secondaryLeadStatus'] = firstValue;
    }

    object = finalObject

    this.leadService.editLead(object, this.leadId).subscribe(
      (response) => {
        if (response['status_code'] == Constant.RESPONSE_SUCCESS) {
          this.snackBar.open(response['status_message'] || 'Successfully Updated', '×', { panelClass: 'success', verticalPosition: 'bottom', duration: 3000 });
          this.text = "Save";
          this.editMode = false;
          this.getAllLeadDetails(this.leadId);


        } else {
          this.text = "Save";
          this.snackBar.open(response['status_message'], '×', { panelClass: 'error', verticalPosition: 'bottom', duration: 3000 });
        }
        this.loaderService.hide();
      },
      (err) => {
        this.text = "Save";
        this.loaderService.hide();
      });
  }
  callicon(icon) {
    if (icon.icon == 'note') {
      this.createNote(null, 0);
    }
    else if (icon.icon == 'call') {
      this.makeCallConnections(this.LeadDetailsObject);
    }
    else if (icon.icon == 'event') {
      this.router.navigate(['/googleCalender']);
    }
  }
  createNote(note: any, noteId: any) {
    if (window.innerWidth > 768) {

      let dialogRef = this.dialog.open(CrmNoteComponent, {
        width: '790px',
        disableClose: true,
        data: {
          "leadId": this.leadId,
          "note": note,
          "noteId": noteId,
          "type": 1,
          "designType": 1,
          "crmType": this.notesType,
          "title": " Add Notes to your lead!"
        }

      });

      dialogRef.disableClose = true;
      dialogRef.afterClosed().subscribe(result => {
        if (result['event'] == 'add') {
          this.getLeadNote(this.leadId);
        }
      });

    }
    else {
      let dialogRef = this.dialog.open(CrmNoteComponent, {
        minWidth: '100vw', height: '100vh',
        data: {
          "leadId": this.leadId,
          "note": note,
          "noteId": noteId,
          "type": 1,
          "designType": 1,
          "crmType": this.notesType,
          "title": " Add Notes to your lead!"
        }
      });

      dialogRef.disableClose = true;
      dialogRef.afterClosed().subscribe(result => {
        if (result['event'] == 'add') {
          this.getLeadNote(this.leadId);
        }

      });
    }
  }

  createDocument(note: any, noteId: any) {
    if (window.innerWidth > 768) {

      let dialogRef = this.dialog.open(CrmNoteComponent, {
        width: '790px',
        disableClose: true,
        data: {
          "leadId": this.leadId,
          "note": note,
          "noteId": noteId,
          "type": 1,
          "designType": 2,
          "title": "Attach Document"
        }

      });

      dialogRef.disableClose = true;
      dialogRef.afterClosed().subscribe(result => {
        if (result['event'] == 'add') {
          this.getLeadNote(this.leadId);
        }
      });

    }
    else {
      let dialogRef = this.dialog.open(CrmNoteComponent, {
        minWidth: '100vw', height: '100vh',
        data: {
          "leadId": this.leadId,
          "note": note,
          "noteId": noteId,
          "type": 1,
          "designType": 2,
          "title": "Attach Document"
        }
      });

      dialogRef.disableClose = true;
      dialogRef.afterClosed().subscribe(result => {
        if (result['event'] == 'add') {
          this.getLeadNote(this.leadId);
        }

      });
    }
  }

  createPayment(note: any, noteId: any) {
    if (window.innerWidth > 768) {

      let dialogRef = this.dialog.open(CrmNoteComponent, {
        width: '790px',
        disableClose: true,
        data: {
          "leadId": this.leadId,
          "note": note,
          "noteId": noteId,
          "type": 1,
          "designType": 3,
          "title": "Payment"
        }

      });

      dialogRef.disableClose = true;
      dialogRef.afterClosed().subscribe(result => {
        if (result['event'] == 'add') {
          this.getLeadNote(this.leadId);
        }
      });

    }
    else {
      let dialogRef = this.dialog.open(CrmNoteComponent, {
        minWidth: '100vw', height: '100vh',
        data: {
          "leadId": this.leadId,
          "note": note,
          "noteId": noteId,
          "type": 1,
          "designType": 3,
          "title": "Payment"
        }
      });

      dialogRef.disableClose = true;
      dialogRef.afterClosed().subscribe(result => {
        if (result['event'] == 'add') {
          this.getLeadNote(this.leadId);
        }

      });
    }
  }


  sortParam1: any = 'noteId' + "," + Constant.Dsc;
  sortParam2: any = 'id' + "," + Constant.Dsc;

  getLeadNote(leadId) {

    this.crmNoteService.getAllNoteByLeadId(leadId, "1").subscribe(
      res => {
        this.noteList = res;


      },
      error => {

      }
    )
  }


  @ViewChild('delete') delete: TemplateRef<any>;

  deleteLeadDialog(activityId) {

    this.activityId = activityId;
    let dialogRef = this.dialog.open(this.delete, {
      width: '350px',
      disableClose: true,

    });
    dialogRef.disableClose = true;
  }


  submit() {
    this.deleteAllLead(this.id);
    this.dialog.closeAll();
    this.init = false;
    this.getAllLeadActivity(this.leadId);
  }

  resourcePrivilege: any;
  spinner: boolean;

  deleteAllLead(id: any) {
    this.spinner = true;
    this.textAccount = "Processing";
    this.leadActivityService.deleteByLeadActivityId(this.activityId).subscribe(
      response => {
        this.spinner = false;
        if (response['status_code'] == Constant.RESPONSE_SUCCESS) {
          this.snackBar.open(response['status_message'], '×', { panelClass: 'success', verticalPosition: 'bottom', duration: 500 });
          this.getAllLeadActivity(this.leadId);
        } else {
          this.snackBar.open(response['status_message'], '×', { panelClass: 'error', verticalPosition: 'bottom', duration: 500 });
        }
        this.textAccount = "OK";
      },
      error => {
        this.textAccount = "OK";
        this.spinner = false;
      })
  }


  @ViewChild('makeConnection') makeConnection: TemplateRef<any>;

  makeCallConnections(LeadDetailsObject) {
    let dialogRef = this.dialog.open(CallListComponent, {
      width: '350px',
      disableClose: true,
      data: { data: LeadDetailsObject }

    });
    dialogRef.disableClose = true;

  }

  makeCall() {
    if (this.textCall == 'Call') {
      this.spinner = true;
      this.leadActivityService.makeCall(this.LeadDetailsObject).subscribe(
        response => {
          this.spinner = false;
          if (response['status_code'] == Constant.RESPONSE_SUCCESS) {
            this.snackBar.open(response['status_message'], '×', { panelClass: 'success', verticalPosition: 'bottom', duration: 300 });
            this.dialog.closeAll();
          } else {
            this.snackBar.open(response['status_message'], '×', { panelClass: 'error', verticalPosition: 'bottom', duration: 300 });
          }
          this.dialog.closeAll();
        },
        error => {
          this.spinner = false;
        });

    }

  }


  //leadStatus

  filtereddropdownTypeList: any;

  defaultLeadStatus: FormControl = new FormControl('');

  dropdownTypeList: any;
  dropdownList: any;
  protected _onDestroy = new Subject<void>();
  public typeYFilterControl: UntypedFormControl = new UntypedFormControl();


  getLeadDropDownList() {

    this.leadStatusService.getAllLeadStatusDropDown(0).subscribe(
      res => {
        this.dropdownList = res;
        this.dropdownTypeList = res;
        this.filtereddropdownTypeList = this.dropdownTypeList;
        this.currentStatusIndex = this.filtereddropdownTypeList.findIndex(
          s => s.statusName === this.LeadDetailsObject.statusName
        );


      },
      error => {
      })
  }

  copyToClipboard(text: string) {
    navigator.clipboard.writeText(text || '');
    this.snackBar.open('Copied to clipboard!', 'X', {
      duration: 3000,
      verticalPosition: 'bottom',
      panelClass: ['success'],
    });
  }


  typeYFilter() {
    this.typeYFilterControl.valueChanges
      .pipe(takeUntil(this._onDestroy))
      .subscribe(() => {
        this.typeidYFilter();
      });
  }


  protected typeidYFilter() {
    if (!this.dropdownTypeList) {
      return;
    }
    let search = this.typeYFilterControl.value;
    if (!search) {
      this.filtereddropdownTypeList = this.dropdownTypeList.slice();
      return;
    } else {
      search = search.toLowerCase();
    }
    // filter the banks
    this.filtereddropdownTypeList = this.dropdownTypeList.filter(status => status['statusName'].toLowerCase().indexOf(search) > -1)
  }

  getAlldropdowntype() {
    this.filtereddropdownTypeList = this.dropdownTypeList;
  }


  object = {
    "entity_type": "Lead",
    "entity_id": "1",
    "entity_name": "yesh",
    "entity_number": "893972994",
    "tenant_id": " Account Id",
    "user_email": "calsoft_agent01@doocti.com",
    "user_id": "1",
    "user_number": "362"
  }

  @ViewChild('scrollContainer') scrollContainer!: ElementRef;

  isDeal(): boolean {
    return this.url.includes('deals') || this.url.includes('type=deal');
  }

  @ViewChild('myFrame') myFrame: ElementRef;
  callANumber(number) {

    const iframeWindow = this.myFrame.nativeElement.contentWindow;

    window.addEventListener('message', this.receiveMessage.bind(this));

    const postData = {
      "entity_type": "Lead",
      "entity_id": this.LeadDetailsObject.entityId,
      "entity_name": this.LeadDetailsObject.name,
      "entity_number": this.LeadDetailsObject.phoneNumber.toString(),
      "tenant_id": "Account Id",
      "user_email": this.LeadDetailsObject.ownerEmail,
      "user_id": this.LeadDetailsObject.ownerId,
      "user_number": "362"
    };

    iframeWindow.postMessage(postData, 'https://crm-app.doocti.com');
  }


  receiveMessage(event: MessageEvent) {

    if (event.origin !== 'https://crm-app.doocti.com') {
      return;
    }

  }

  opendialCall() {
    document.getElementById("mydailer").style.display = "block";
    this.dialerShow = true;
  }

  dialClose() {
    document.getElementById("mydailer").style.display = "none";
    this.dialerShow = false;
  }

  isMinimized = false;

  minimizeToggle() {
    this.isMinimized = !this.isMinimized;
  }


  download(value) {
    let smallImage = "/coursepdf/" + value;
    this.productService.downloadPdf(smallImage).subscribe(
      data => {
        downloads(data);
      },
    )
  }

  back() {
    this.location.back()
  }

  navigateToInvoice(LeadDetailsObject) {
    const encryptedLeadDetailsObject = this.ecryptService.encryptionAES(JSON.stringify(LeadDetailsObject));
    localStorage.setItem('leadDetailObjectData', encryptedLeadDetailsObject);

    this.leadId = LeadDetailsObject.entityId
    this.router.navigate([`/invoice-generation/${this.leadId}`])
  }
  navigateToQuotation(LeadDetailsObject) {
    const encryptedLeadDetailsObject = this.ecryptService.encryptionAES(JSON.stringify(LeadDetailsObject));
    localStorage.setItem('leadDetailObjectData', encryptedLeadDetailsObject);

    this.leadId = LeadDetailsObject.entityId
    this.router.navigate([`/invoice-generation/quotation-generate/${this.leadId}`])
  }


  onFormSubmitted(event) {



    this.finalValueForm = event;


  }

  createDynamicForm(event, formGroupId, statusId) {

    if (event.isUserInput != false) {

      this.patchValues.LeadStatus = statusId

      this.formInit = false;

      this.getFormArray(formGroupId)
    }

  }


  regConfig: any[] = [];

  getFormArray(formGroupId) {

    this.dynamicFormLabelService.getDynmaicForm(formGroupId).subscribe((data) => {


      let value: any = data

      if (value.length > 0) {
        this.regConfig = value;

        this.newType = 2;
        this.formInit = true;

        this.defaultForm = true;

        this.changeDetector.detectChanges();
      } else {
        console.log("No form fields found for this Form Group ID");
      }


    });
  }
  toggleFavorite(leadData: any): void {

    leadData.favourite = leadData.favourite == 1 ? 0 : 1;


    let updatedLeadEntity = {

      entityId: leadData.entityId,
      favourite: leadData.favourite

    }

    this.loaderService.show();

    this.leadService.editLead(updatedLeadEntity, leadData.entityId).subscribe(
      response => {

        if (response['status_code'] == Constant.RESPONSE_SUCCESS) {
          this.snackBar.open(response['status_message'], '×', { panelClass: 'success', verticalPosition: 'bottom', duration: 500 });
          this.text = "Save";
          this.editMode = false;
          this.updateType = 'WalkIn';
          this.getAllLeadDetails(this.leadId);


        } else {
          this.text = "Save";
          this.snackBar.open(response['status_message'], '×', { panelClass: 'error', verticalPosition: 'bottom', duration: 500 });
        }


        this.loaderService.hide();

      },
      error => {
        this.loaderService.hide();

      }
    );
  }

  walkIn(leadData: any): void {

    leadData.walkIn = leadData.walkIn == 1 ? 0 : 1;
    let updatedLeadEntity = {

      entityId: leadData.entityId,
      walkIn: leadData.walkIn

    }
    this.loaderService.show();
    this.leadService.editLead(updatedLeadEntity, leadData.entityId).subscribe(
      response => {

        if (response['status_code'] == Constant.RESPONSE_SUCCESS) {
          this.snackBar.open(response['status_message'], '×', { panelClass: 'success', verticalPosition: 'bottom', duration: 500 });
          this.text = "Save";
          this.editMode = false;
          this.updateType = 'WalkIn';
          this.getAllLeadDetails(this.leadId);


        } else {
          this.text = "Save";
          this.snackBar.open(response['status_message'], '×', { panelClass: 'error', verticalPosition: 'bottom', duration: 500 });
        }
        this.loaderService.hide();

      },
      error => {
        this.loaderService.hide();

      }
    );
  }

  phonewhatsapp(data) {

    if (this.whatsAppCustomUrl == 0) {

      let message = `Hi ${data.name}, I'm from ${this.storeName}.`;

      let phoneNumber = data.phoneNumber.replace(/\D/g, "");

      let url = `https://wa.me/${encodeURIComponent(phoneNumber)}?text=${encodeURIComponent(message)}`;

      window.open(url, '_blank');

    } else if (this.whatsAppCustomUrl == 2) {
      let contactUid = data?.whatsappContactUid || data?.contactUid || data?.uid;
      let rawPhone = data?.phoneNumber || data?.mobile || data?.phone || '';
      let phoneNumber = rawPhone ? rawPhone.toString().replace(/\D/g, "") : '';
      let target = contactUid || phoneNumber;

      if (target) {
        this.dialog.closeAll();
        this.router.navigate(['/whatsAppChat'], { queryParams: { contact: target } });
      } else {
        alert("Contact information not available");
      }
    } else {

      let url = this.whatAppUrl;
      if (url != null) {
        window.open(url, '_blank');
      } else {
        alert("Please Update CrmSetting")
      }

    }
  }

  phoneSms(data) {

    let phoneNumber = data.phoneNumber.replace(/\D/g, "");

    // window.location.href = "sms:" + phoneNumber;

    let message = `Hi ${data.name}, I'm from ${this.storeName}.`;

    window.location.href = `sms:${phoneNumber}?&body=${encodeURIComponent(message)}`;

  }

  navigatelink(value) {

    window.open(value, '_blank');

  }

  openEditDialog(): void {
    const dialogRef = this.dialog.open(EditprofileComponent, {
      width: '400px',
      data: {
        firstName: this.LeadDetailsObject.firstName,
        lastName: this.LeadDetailsObject.lastName,
        jobTitle: this.LeadDetailsObject.jobTitle
      }
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        this.LeadDetailsObject.firstName = result.firstName;
        this.LeadDetailsObject.lastName = result.lastName;
        this.LeadDetailsObject.name = `${result.firstName} ${result.lastName}`;
        this.LeadDetailsObject.jobTitle = result.jobTitle;
      }
    });
  }

  getcallList() {

    let sortParam: any = 'id' + "," + Constant.Dsc;

    // this.search = 'activityType:*OutboundCall,*';

    this.search = `activityType:*OutboundCall,* AND leadId:${this.leadId}`;

    this.spinner = true;
    this.leadActivityService.searchAllActivity(this.search, this.page, this.size, sortParam, this.groupBy).subscribe(
      res => {
        this.spinner = false;
        this.calllist = res['content'];



      },
      error => {
        this.spinner = false;
      })
  }
  openEmailPopup() {
    if (window.innerWidth > 768) {

      let dialogRef = this.dialog.open(EmailPopupComponentComponent, {
        width: '80vw', // or '100%' depending on your container layout
        maxWidth: '80vw',
        height: '100vh', // optional, for full height too
        maxHeight: '100vh',
        // disableClose: true,
        data: {
          email: this.LeadDetailsObject.email,
          name: this.LeadDetailsObject.name,
          leadId: this.leadId,
          type: 1
        },
        position: { right: '0' },
        panelClass: 'slide-dialog-panel',
        hasBackdrop: true,
        disableClose: false
      });
      dialogRef.afterClosed().subscribe(() => {
        this.getAllLeadDetails(this.leadId);
      });
      dialogRef.disableClose = true;


    }
    else {
      let dialogRef = this.dialog.open(EmailPopupComponentComponent, {
        minWidth: '100vw', height: '100vh',
        data: {
          email: this.LeadDetailsObject.email,
          name: this.LeadDetailsObject.name,
          leadId: this.leadId,
          type: 1
        },
        position: { right: '0' },
        panelClass: 'slide-dialog-panel',
        hasBackdrop: true,
        disableClose: false
      });
      dialogRef.afterClosed().subscribe(() => {
        this.getAllLeadDetails(this.leadId);
      });
      dialogRef.disableClose = true;



    }

  }

  emailtemplateId = new FormControl('', [Validators.required]);

  @ViewChild('emailtemplatedata') emailtemplatedata: TemplateRef<any>;

  sendEmailMessage() {
    let dialogRef = this.dialog.open(this.emailtemplatedata, {
      width: '750px',
      disableClose: true,
    });
    dialogRef.disableClose = true;
  }


  // emailTemplateMessage

  protected _onDestroy2 = new Subject<void>();

  emailTemplateMessageList: any;

  filteredEmailTemplateMessageTypeList: any;

  public emailTemplateMessageFilterControl: UntypedFormControl = new UntypedFormControl();

  getEmailTemplateMessageList() {
    this.templateService.getAllEmailSendDropDown().subscribe(
      (res) => {
        this.emailTemplateMessageList = res;
        this.emailTemplateMessageList = this.emailTemplateMessageList;
        this.filteredEmailTemplateMessageTypeList = this.emailTemplateMessageList;
      },
      (error) => { }
    );
  }

  EmailTemplateMessageYFilter() {
    this.emailTemplateMessageFilterControl.valueChanges
      .pipe(takeUntil(this._onDestroy))
      .subscribe(() => {
        this.EmailTemplateMessageFilter();
      });
  }

  protected EmailTemplateMessageFilter() {
    if (!this.emailTemplateMessageList) {
      return;
    }
    let search = this.emailTemplateMessageFilterControl.value;
    if (!search) {
      this.filteredEmailTemplateMessageTypeList = this.emailTemplateMessageList.slice();
      return;
    } else {
      search = search.toLowerCase();
    }

    this.filteredEmailTemplateMessageTypeList = this.emailTemplateMessageList.filter(
      (dynamicForm) => dynamicForm['templateName'].toLowerCase().indexOf(search) > -1
    );
  }

  getAllEmailTemplateMessage() {
    this.filteredEmailTemplateMessageTypeList = this.emailTemplateMessageList;
  }

  sendMailTemplate() {
    if (this.textSend == 'Send' && this.emailtemplateId.valid) {

      this.textSend = "Processing"

      const requestBody = [
        {
          leadId: this.leadId,
        }
      ];

      this.templateService.sendEmailMessage(requestBody, this.emailtemplateId.value).subscribe(
        (response) => {
          if (response['status_code'] == Constant.RESPONSE_SUCCESS) {
            this.textSend = "Send";
            this.dialog.closeAll();
            this.snackBar.open(response['status_message'], '×', { panelClass: 'success', verticalPosition: 'bottom', duration: 500 });
          }
          else {
            this.dialog.closeAll();
            this.textSend = "Send";
            this.snackBar.open(response['status_message'], '×', { panelClass: 'error', verticalPosition: 'bottom', duration: 500 });
          }
        },
        (err) => {
          this.dialog.closeAll();
          this.textSend = "Send"
        });
    }
    else {
      this.firstFormGroup.markAllAsTouched();
    }
  }

  phoneNumbercall(data) {

    if (this.webMobileCallEnable == 1) {

      this.leadActivityService.sendWebToMobileCall(data).subscribe(
        (response) => {
          if (response['status_code'] == Constant.RESPONSE_SUCCESS) {
            this.snackBar.open(response['status_message'], '×', { panelClass: 'success', verticalPosition: 'bottom', duration: 500 });
          }
          else {
            this.snackBar.open(response['status_message'], '×', { panelClass: 'error', verticalPosition: 'bottom', duration: 500 });
          }
        },
        (err) => { });

    } else {

      if (this.dialerType == 1) {
        this.leadActivityService.makeCall(data).subscribe(
          response => {
            if (response['status_code'] == Constant.RESPONSE_SUCCESS) {
              this.snackBar.open(response['status_message'], '×', { panelClass: 'success', verticalPosition: 'bottom', duration: 300 });
              this.dialog.closeAll();
            } else {
              this.snackBar.open(response['status_message'], '×', { panelClass: 'error', verticalPosition: 'bottom', duration: 300 });
            }
            this.dialog.closeAll();
          },
          error => {

          });
      }
      else if (this.dialerType == 2) {
        this.opendialCallsa(data)
        this.callANumber1(data, data.phoneNumber)
      }

      else if (this.dialerType == 3) {
        this.loaderService.show();
        this.leadActivityService.makeDooctiClickToCall(data).subscribe(
          response => {
            if (response['status_code'] == Constant.RESPONSE_SUCCESS) {
              this.snackBar.open(response['status_message'], '×', { panelClass: 'success', verticalPosition: 'bottom', duration: 300 });


            } else {
              this.snackBar.open(response['status_message'], '×', { panelClass: 'error', verticalPosition: 'bottom', duration: 300 });
            }
            this.loaderService.hide();

          },
          error => {
            this.loaderService.hide();
          });

      }
      else if (this.dialerType == 5 || this.dialerType == 9) {
        this.loaderService.show();
        this.leadActivityService.makeTelecmi(data).subscribe(
          response => {
            if (response['status_code'] == Constant.RESPONSE_SUCCESS) {
              this.snackBar.open(response['status_message'], '×', { panelClass: 'success', verticalPosition: 'bottom', duration: 300 });


            } else {
              this.snackBar.open(response['status_message'], '×', { panelClass: 'error', verticalPosition: 'bottom', duration: 300 });
            }
            this.loaderService.hide();

          },
          error => {
            this.loaderService.hide();
          });

      }
      else if (this.dialerType == 6) {
        this.loaderService.show();
        this.leadActivityService.clickToCallAcefone(data).subscribe(
          response => {
            if (response['status_code'] == Constant.RESPONSE_SUCCESS) {
              this.snackBar.open(response['status_message'], '×', { panelClass: 'success', verticalPosition: 'bottom', duration: 300 });


            } else {
              this.snackBar.open(response['status_message'], '×', { panelClass: 'error', verticalPosition: 'bottom', duration: 300 });
            }
            this.loaderService.hide();

          },
          error => {
            this.loaderService.hide();
          });

      }
      else if (this.dialerType == 7) {
        this.callANumberNew(data)
      }
      else if (this.dialerType == 8) {
        if (window.innerWidth > 768) {

          let dialogRef = this.dialog.open(TwilloDialerComponent, {
            // width: '400px',
            height: 'auto',          // optional
            position: {
              bottom: '2px',        // distance from bottom
              right: '2px'          // distance from right
            },
            disableClose: true,
            data: {
              phone: data.phoneNumber
            }
          });

          dialogRef.disableClose = true;
          dialogRef.afterClosed().subscribe(result => {
            if (result['event'] == 'add') {

            }
          });

        }
        else {
          let dialogRef = this.dialog.open(TwilloDialerComponent, {
            minWidth: '100vw', height: '100vh',
            data: {
              phone: data.phoneNumber
            }
          });
          dialogRef.disableClose = true;
          dialogRef.afterClosed().subscribe(result => {
            if (result['event'] == 'add') {

            }
          });
        }
      }

      else if (this.dialerType == 10) {
        this.loaderService.show();
        this.leadActivityService.callForBuzzDieal(data).subscribe(
          response => {
            if (response['status_code'] == Constant.RESPONSE_SUCCESS) {
              this.snackBar.open(response['status_message'], '×', { panelClass: 'success', verticalPosition: 'bottom', duration: 300 });


            } else {
              this.snackBar.open(response['status_message'], '×', { panelClass: 'error', verticalPosition: 'bottom', duration: 300 });
            }
            this.loaderService.hide();

          },
          error => {
            this.loaderService.hide();
          });

      }
      else if (this.dialerType == 11) {
        this.loaderService.show();
        this.leadActivityService.calltoElevenlabs(data).subscribe(
          response => {
            if (response['status_code'] == Constant.RESPONSE_SUCCESS) {
              this.snackBar.open(response['status_message'], '×', { panelClass: 'success', verticalPosition: 'bottom', duration: 300 });


            } else {
              this.snackBar.open(response['status_message'], '×', { panelClass: 'error', verticalPosition: 'bottom', duration: 300 });
            }
            this.loaderService.hide();

          },
          error => {
            this.loaderService.hide();
          });

      }

      else {
        this.loaderService.hide();
        this.addLeadActivity('Phone Call', 0, data);
      }
    }
  }

  opendialCallsa(data) {
    document.getElementById("mydailer").style.display = "block";
    this.dialerShow = true;
    this.data = data
  }



  callANumber1(number, phone) {

    const iframeWindow = this.myFrame.nativeElement.contentWindow;

    window.addEventListener('message', this.receiveMessage.bind(this));


    const postData = {
      "entity_type": "Lead",
      "entity_id": number.entityId,
      "entity_name": number.name,
      "entity_number": phone.toString(),
      "tenant_id": "Account Id",
      "user_email": number.ownerEmail,
      "user_id": number.ownerId,
      "user_number": "362"
    };

    iframeWindow.postMessage(postData, 'https://crm-app.doocti.com');
  }

  editEmailSend(id) {
    this.router.navigate([`/emailSend/editEmailSend/${id}`])
  }

  emailList: any;

  getAllEmailSend(leadId) {
    this.emailSendService.getAllEmailByLeadId(leadId).subscribe(
      res => {
        this.emailList = res;


      },
      error => {

      }
    )
  }

  groupedActivities: { [key: string]: any[] } = {};
  selectTabInner(tabName: string): void {
    if (!tabName) tabName = 'activity';
    this.activeTabInner = tabName;
    if (tabName === 'Email Sent' || tabName === 'Email' || tabName === 'Email Status') {
      if (!this.currentMailBox) {
        this.currentMailBox = 'INBOX';
      }
      this.loadEmails({ value: this.currentMailBox });
    }
  }
  getRelativeTime(dateString: string): string {
    const activityDate = new Date(dateString);
    const now = new Date(); // Using component initialization time for consistency
    const diffInSeconds = Math.floor((now.getTime() - activityDate.getTime()) / 1000);

    const intervals: { [key: string]: number } = {
      'year': 31536000,
      'month': 2592000,
      'day': 86400,
      'hour': 3600,
      'minute': 60
    };

    for (const intervalName in intervals) {
      const interval = intervals[intervalName];
      const count = Math.floor(diffInSeconds / interval);
      if (count > 0) {
        return `${count} ${intervalName}${count > 1 ? 's' : ''} ago`;
      }
    }
    return 'Just now';
  }
  getIconForActivity(type: string, activity?: any): string {
    const rawType = (type || activity?.activityType || activity?.type || '').toString().trim();
    const t = rawType.toLowerCase();

    if (
      t.includes('phone') ||
      t.includes('call') ||
      t.includes('mobile') ||
      t === 'incoming' ||
      t === 'outgoing' ||
      t === 'connected'
    ) {
      return 'phone';
    }

    if (
      t.includes('stage') ||
      t.includes('dealstatus') ||
      t === 'statuschange'
    ) {
      return 'track_changes';
    }

    switch (t) {
      case 'task': return 'check_box_outline_blank';
      case 'meeting': return 'groups';
      case 'email': return 'mail_outline';
      case 'stagechange': return 'track_changes';
      case 'ownerchange': return 'person_outline';
    }

    if (t.includes('email')) return 'mail_outline';
    if (t.includes('payment')) return 'payments';
    if (t.includes('meeting')) return 'groups';
    if (t.includes('owner')) return 'person_outline';
    if (t.includes('task') || t === 'follow up') return 'check_box_outline_blank';

    const act = activity || {};
    const content = `${act.subject || ''} ${act.notes || ''} ${act.title || ''} ${act.description || ''} ${act.fieldName || ''}`.toLowerCase();
    if (content.includes('deal stage') || content.includes('stage')) {
      return 'track_changes';
    }
    if (content.includes('phone number') || content.includes('phone') || content.includes('mobile')) {
      return 'phone';
    }

    return 'history_toggle_off'; // A generic fallback icon
  }
  getAllLeadActivity(leadId) {

    this.onScrollValue = true;

    this.leadActivityService.getAllLeadActivityByPageable(0, 10, 'id,desc', leadId, "1").subscribe(
      data => {

        this.totalSize = data["totalPages"];

        this.leadActivityList = data['content'];

        this.leadActivityListFinal = data;

        this.processActivities();

        this.totalActivity = data['totalElements']

        this.init = true;

        this.pagetwo = 0;

        this.loaderService.hide();

      },
      error => {
        this.onScrollValue = false;


      })
  }

  leadActivityListTasks: any = [];
  leadActivityListFinalTasks: any;

  getAllLeadActivityTasks(leadId) {

    this.onScrollValue = true;

    this.leadActivityService.getAllLeadActivityByPageableNew(0, 10, 'id,desc', leadId, "1").subscribe(
      data => {

        this.totalSize = data["totalPages"];

        this.leadActivityListTasks = data['content'];

        this.leadActivityListFinalTasks = data;

        this.processTasks();

        this.totalActivity = data['totalElements'];

        this.init = true;

        this.pagetwo = 0;

        this.loaderService.hide();

      },
      error => {
        this.onScrollValue = false;

      })
  }

  onTaskUpdated() {
    if (this.leadId) {
      this.getAllLeadActivity(this.leadId);
      this.getAllLeadActivityTasks(this.leadId);
      this.getAllLeadActivityUpcoming();
      this.getAllLeadActivityDue();
      this.getAllLeadActivityCompleted();
    }
  }
  private processActivities(): void {

    const sortedActivities = this.leadActivityList.sort((a, b) =>
      new Date(b.createdDate).getTime() - new Date(a.createdDate).getTime()
    );

    const groups: { [key: string]: any[] } = {};
    const datePipe = new DatePipe('en-US');

    for (const activity of sortedActivities) {
      const dateKey = datePipe.transform(activity.createdDate, 'MMMM d, yyyy')!;
      if (!groups[dateKey]) {
        groups[dateKey] = [];
      }
      groups[dateKey].push(activity);
    }
    this.groupedActivities = groups;
  }
  private processTasks(): void {
    const list = this.leadActivityListTasks || [];
    this.taskCounts.all = list.length;
    this.taskCounts.completed = list.filter(t => t.isCompleted).length;
    this.taskCounts.overdue = list.filter(t => !t.isCompleted && new Date(t.dueDate) < new Date()).length;
    this.taskCounts.upcoming = list.filter(t => !t.isCompleted && new Date(t.dueDate) >= new Date()).length;

    this.setTaskFilter('all');
  }
  filteredTasks: any[] = [];
  activeTaskFilter: string = 'all';
  setTaskFilter(filter: string): void {
    this.activeTaskFilter = filter;
    switch (filter) {
      case 'upcoming':
        this.filteredTasks = this.leadActivityList.filter(t => !t.isCompleted && new Date(t.dueDate) >= new Date());
        break;
      case 'overdue':
        this.filteredTasks = this.leadActivityList.filter(t => !t.isCompleted && new Date(t.dueDate) < new Date());
        break;
      case 'completed':
        this.filteredTasks = this.leadActivityList.filter(t => t.isCompleted);
        break;
      case 'all':
      default:
        this.filteredTasks = this.leadActivityList;
        break;
    }
  }
  isOverdue(task: any): boolean {
    return !task.isCompleted && new Date(task.dueDate) < new Date();
  }


  pagetwo = 0;
  isMobileView: boolean = false;
  selectedIndex: number | null = null;
  onScroll() {
    if (this.pagetwo < this.totalSize - 1) {
      this.spinner = true;
      this.onScrollValue = true;
      this.pagetwo++;

      this.leadActivityService.getAllLeadActivityByPageableNew(this.pagetwo, 10, 'id,desc', this.leadId, "1").subscribe(
        res => {
          if (res['content']?.length) {
            this.leadActivityList = [...this.leadActivityList, ...res['content']];
          }

          this.totalSize = res["totalPages"];
          this.isEmpty = res["empty"];
          this.onScrollValue = this.pagetwo < this.totalSize - 1;
          this.spinner = false;
        },
        error => {
          console.error("Error loading activity:", error);
          this.spinner = false;
          this.onScrollValue = false;
        }
      );
    } else {
      this.spinner = false;
      this.onScrollValue = false;
    }
  }





  //for email 
  extractEmailAddress(from: string): string {
    const match = from.match(/<(.+?)>|(\b[A-Za-z0-9._%+-]+@[A-Za-z0-9.-]+\.[A-Z]{2,}\b)/i);
    return match ? (match[1] || match[2]) : from;
  }
  truncateText(text: string, limit: number = 150): string {
    return text?.length > limit ? text.substring(0, limit) + '...' : text;
  }
  addDeal(dealId: number, companyId: number) {
    this.dialog.closeAll();
    if (this.companyId > 0) {
      this.router.navigate([`deals/add-edit-deals/${dealId}/${this.dealSetId}/${this.leadId}/${this.companyId}`])

    } else {
      this.router.navigate([`deals/add-edit-deals/${dealId}/${this.dealSetId}/${this.leadId}`])
    }

  }

  loadEmails(event?: any) {

    this.isLoading = true;
    this.selectedIndex = null;
    this.emailVisble = false;

    if (!event || !event.value) {
      event = { value: this.currentMailBox || 'INBOX' };
    }

    this.currentMailBox = event.value;

    const emailToFilter = this.LeadDetailsObject?.email;
    let timeoutTriggered = false;
    const loadingTimeout = setTimeout(() => {
      timeoutTriggered = true;
      this.isLoading = false;
      console.warn('Email loading timeout exceeded');
    }, 10000);

    this.mailBox
      .filterByEmail(this.pageIndex, this.pageSizeEmail, event.value, emailToFilter)
      .subscribe({
        next: (response) => {
          if (timeoutTriggered) return;
          this.emails = response['data']['emails']?.map((email: any) => this.transformEmailDto(email)) || [];
          this.totalEmails = response['data']['totalMessages'];
          if (this.emails.length > 0) {
            this.selectEmail(0);
          }
        },
        error: (error) => {
          console.error('Error fetching filtered emails:', error);
        }
      })
      .add(() => {
        if (!timeoutTriggered) {
          clearTimeout(loadingTimeout);
          this.isLoading = false;
        }
      });
  }

  selectEmail(index: number): void {
    this.selectedIndex = index;
    this.emailObject = this.emails[index];
    this.selectedEmail = this.emails[index];
    this.emailVisble = true;
  }


  transformEmailDto(email: any): any {
    const rawBody = email.body && String(email.body).trim();
    const bodyContent = rawBody ? email.body : (email.snippet || '');
    return {
      ...email,
      subject: email.subject || '(No Subject)',
      body: bodyContent,
      attachments: email.attachments || [],
      sentDate: new Date(email.sentDate)
    };
  }
  goToMailbox() {
    this.dialog.closeAll();
    this.router.navigate(['/mailBox']);
  }
  onPageChange(event: PageEvent) {
    this.pageIndex = event.pageIndex;
    this.pageSizeEmail = event.pageSize;

  }
  linkifyAndSanitize(html: string): SafeHtml {
    const cleanedHtml = this.extractBodyContent(html);
    return this.sanitizer.bypassSecurityTrustHtml(cleanedHtml);
  }

  isImage(contentType: string): boolean {
    return contentType.startsWith('image/');
  }


  extractBodyContent(html: string): string {
    const bodyMatch = html.match(/<body[^>]*>([\s\S]*?)<\/body>/i);
    let bodyContent = bodyMatch ? bodyMatch[1] : html;

    bodyContent = bodyContent
      .replace(/<!DOCTYPE[^>]*>/gi, '')
      .replace(/<html[^>]*>|<\/html>/gi, '')
      .replace(/<head[^>]*>[\s\S]*?<\/head>/gi, '')
      .replace(/<style[^>]*>[\s\S]*?<\/style>/gi, '')
      .trim();

    return bodyContent;
  }
  //lead activity 
  truncateSafeHTML(html: string, length: number): string {
    const div = document.createElement('div');
    div.innerHTML = html;
    const text = div.innerText || '';
    return text.length > length ? text.substring(0, length) + '…' : text;
  }

  save() {
    this.showEditPopup = false;
  }




  showEditPopup = false;


  openEditPopup1() {
    this.showEditPopup = true;
  }

  closeEditPopup() {
    this.showEditPopup = false;
  }

  @ViewChild(SimpleDynamicFormComponent, { static: false })
  simpleDynamicFormComponent:
    SimpleDynamicFormComponent;
  submitNew() {

    if (this.regConfig.length > 0) {
      this.type = 2;
      this.simpleDynamicFormComponent.onSubmitNew();

    } else {
      this.firstFormGroup.value.dynamicFieldValues = [];
      this.checkLeadExist();
    }


  }

  saveNew(event) {

    this.checkLeadExist();
  }

  defaultConfig: any[] = [];

  getDefaultForm(formGroupId) {

    this.dynamicFormLabelService.getDynmaicForm(formGroupId).subscribe((data) => {


      let value: any = data

      if (value.length > 0) {
        this.defaultConfig = value;

        this.newType = 2;

        this.defaultForm = true;

      } else {
        console.log("No form fields found for this Form Group ID");
      }


    });
  }


  dialerEnable: boolean = false;
  lastDialedNumber: any;

  newdialer(number) {
    this.dialerEnable = true;
    this.lastDialedNumber = number;
    if (this.dialerType == 7) {
      this.initDialer();
      //  this.callANumberNew(number)
    }

  }

  iframeUrl: string = '';

  initDialer() {

    const userId = localStorage.getItem('userId');
    const companyId = localStorage.getItem('storeName');

    const baseUrl = 'https://client5.rekzyl.com/voice/dialpad';
    const params = new URLSearchParams({
      leftServiceId: '93eeb600-dcb1-4382-bf11-846c4f67deb79',
      service: 'calsoft',
      sideBar: 'false',
      topBar: 'false',
      fullView: 'false',
      userId: userId,
      companyId: companyId,
    });

    this.iframeUrl = `${baseUrl}?${params.toString()}`;
    this.changeDetector.detectChanges();
  }

  @ViewChild('myHelloSendFrame', { static: false }) myHelloSendFrame: ElementRef;

  onIframeLoaded() {
    setTimeout(() => {
      if (!this.myHelloSendFrame?.nativeElement) {
        console.error('iframe element not yet available');
        return;
      }
      this.callANumberNew(this.lastDialedNumber);
    }, 0); // allow next change detection cycle
  }

  callANumberNew(number: string) {
    const iframeWindow = this.myHelloSendFrame?.nativeElement?.contentWindow;

    if (!iframeWindow) {
      console.error('Iframe window is not available');
      return;
    }

    const postData = {
      entity_type: "Lead",
      entity_id: this.LeadDetailsObject.entityId,
      entity_name: this.LeadDetailsObject.name,
      entity_number: this.LeadDetailsObject.phoneNumber.toString(),
      user_email: this.LeadDetailsObject.ownerEmail,
      user_id: this.LeadDetailsObject.ownerId,
      event_action: "click2call"
    };

    iframeWindow.postMessage(postData, 'https://client5.rekzyl.com');

    const messageHandler = (event: MessageEvent) => {
      if (event.origin !== 'https://client5.rekzyl.com') return;
      console.log('Response received from iframe:', event.data);
      window.removeEventListener('message', messageHandler);
    };

    window.addEventListener('message', messageHandler);
  }

  closeDialer() {
    this.dialerEnable = false;
  }

  sendDialPadAction(action: 'MAXIMIZE_DIAL_PAD' | 'MINIMIZE_DIAL_PAD') {
    const iframeWindow = this.myHelloSendFrame?.nativeElement?.contentWindow;

    if (!iframeWindow) {
      console.error('Iframe is not ready to receive messages');
      return;
    }

    const postMessageData = {
      event_action: action
    };

    iframeWindow.postMessage(postMessageData, 'https://client5.rekzyl.com');
  }


  // Helper to generate stars for the customer fit rating
  getStars(rating: number): boolean[] {
    return Array(5).fill(false).map((_, i) => i < rating);
  }

  toggleCollapsetwo() {
    this.isCollapsedtwo = !this.isCollapsedtwo;
  }

  activeTab: string = 'Overview';

  selectTabs(tabKey: string): void {
    this.activeTab = tabKey;
    const scrollToTop = () => {
      try {
        window.scrollTo({ top: 0, behavior: 'auto' });
        const scrollContainers = document.querySelectorAll('.content, .right-content-area, .dynamic-content, mat-sidenav-content');
        scrollContainers.forEach(container => {
          const originalScrollBehavior = (container as HTMLElement).style.scrollBehavior;
          (container as HTMLElement).style.scrollBehavior = 'auto';
          container.scrollTop = 0;
          (container as HTMLElement).style.scrollBehavior = originalScrollBehavior;
        });
      } catch (e) {
        console.error('Error scrolling to top:', e);
      }
    };
    scrollToTop();
    setTimeout(scrollToTop, 0);
  }

  editProfileUrl() {

    this.loaderService.show();
    let object = {
      "twitter": this.firstFormGroup.value.twitter,
      "entityId": this.leadId,
      "facebook": this.firstFormGroup.value.facebook,
      "linkedIn": this.firstFormGroup.value.linkedIn,
    }

    delete this.finalValueForm['LeadStatus'];
    let finalObject = { ...object, ...this.finalValueForm };

    const firstValue = Object.values(this.finalValueForm)[0];

    if (firstValue != undefined) {

      finalObject['secondaryLeadStatus'] = firstValue;
    }

    object = finalObject
    this.leadService.editLead(object, this.leadId).subscribe(
      (response) => {
        if (response['status_code'] == Constant.RESPONSE_SUCCESS) {
          this.LeadDetailsObject.twitter = this.firstFormGroup.value.twitter
          this.LeadDetailsObject.facebook = this.firstFormGroup.value.facebook
          this.LeadDetailsObject.linkedIn = this.firstFormGroup.value.linkedIn
          this.snackBar.open(response['status_message'], '×', { panelClass: 'success', verticalPosition: 'bottom', duration: 500 });
          this.text = "Save";
          this.editMode = false;
          this.getAllLeadDetails(this.leadId);


        } else {
          this.text = "Save";
          this.snackBar.open(response['status_message'], '×', { panelClass: 'error', verticalPosition: 'bottom', duration: 500 });
        }
        this.loaderService.hide();
      },
      (err) => {
        this.text = "Save";
        this.loaderService.hide();
      });
  }

  openSocialUrl(type: 'facebook' | 'twitter' | 'linkedIn', event: MouseEvent) {
    event.stopPropagation();
    const url = this.firstFormGroup.get(type)?.value;

    if (url) {
      const fullUrl = url.startsWith('http') ? url : `https://${url}`;
      window.open(fullUrl, '_blank');
    } else {
      this.snackBar.open(`No ${type} URL found`, '×', {
        panelClass: 'error',
        duration: 3000
      });
    }
  }
  activeView: 'all' | 'basic' = 'all';

  // Manages the state of collapsible sections in the 'All details' view
  isBasicInfoOpen = true;
  isMoreFieldsOpen = true;

  // Static contact data from the images
  contact = {
    email: 'janesampleton@gmail.com',
    firstName: 'Jane',
    lastName: 'Sampleton (sample)',
    jobTitle: 'CEO',
    account: 'Widgetz.io (sample)',
    mobilePhone: '+19266529503',
    workPhone: '+13684932360',
    salesOwner: 'Pavitharan',
    tags: ['Decision maker'],
    source: 'Web',
    address: '604-5854 Beckford St.',
    city: 'Glendale',
    state: 'Arizona',
    country: 'USA',
    zipcode: '100652',
    lifecycleStage: 'Lead',
    status: 'New',
    lostReason: null,
    subscriptionStatus: 'Subscribed',
    subscriptionTypes: 'Newsletter, Promotional, Product updates, Conf...',
    unsubscribeReason: null,
    otherUnsubscribeReasons: null,
    score: 52,
    customerFit: 2, // Representing 2 out of 5 stars
    social: {
      linkedin: 'jane-sampleton-0b0039109',
      twitter: 'janesampleton',
      facebook: '100010587455650'
    }
  };

  // Function to switch between 'All details' and 'Basic information' views
  setView(view: 'all' | 'basic'): void {
    this.activeView = view;
  }

  // Functions to toggle the collapsible sections
  toggleBasicInfo(): void {
    this.isBasicInfoOpen = !this.isBasicInfoOpen;
  }

  toggleMoreFields(): void {
    this.isMoreFieldsOpen = !this.isMoreFieldsOpen;
  }

  getCount() {
    this.dealsService.getDeals(0, 1, this.sortParam, this.type, this.leadId).subscribe(
      res => {

        this.noOfDeals = res['numberOfElements'];

      },
      error => {
        this.spinner = false;
      }
    )

    let sortParam = 'googleCalenderId' + "," + Constant.Dsc;
    this.googleCalendarServiceAccountService.getAllGoogleCalendar(0, 1, sortParam, 1, 2, this.leadId, this.meetingType).subscribe(
      res => {
        this.spinner = false;
        this.noOfMeetings = res['numberOfElements'];
      },
      error => {
      }
    )
  }

  goToDeals() {
    let dealId = 0;
    this.dialog.closeAll();
    if (this.companyId > 0) {
      this.router.navigate([`deals/add-edit-deals/${dealId}/${this.dealSetId}/${this.leadId}/${this.companyId}`])

    } else {
      this.router.navigate([`deals/add-edit-deals/${dealId}/${this.dealSetId}/${this.leadId}`])
    }
  }


  goToMeeting() {
    const dialogRef = this.dialog.open(AddMeetingComponent, {
      width: '80%',
      maxWidth: '1200px',
      height: '100%',
      data: {
        "leadId": this.leadId,
        "type": 1
      },
      position: { right: '0' },
      panelClass: 'slide-dialog-panel',
      hasBackdrop: true,
      disableClose: true
    });

    dialogRef.afterClosed().subscribe((result) => {
      if (result && result['event'] === 'add') {
        this.getLeadNote(this.leadId);
        this.getAllLeadActivity(this.leadId);
        this.getAllGoogleCalendar(this.leadId)
      }
    });
  }

  googleCalendarList: any = [];

  getAllGoogleCalendar(leadId) {
    this.spinner = true;

    this.googleCalendarServiceAccountService.getAllGoogleCalendarNew(this.page, this.size, this.sortParam, 1, this.type, leadId, this.meetingType).subscribe(
      res => {
        this.spinner = false;
        this.googleCalendarList = new MatTableDataSource();
        this.googleCalendarList = res['content'];
      },
      error => {
      }
    )
  }

  openViewDialog(): void {
    let image = this.LeadDetailsObject?.image;
    this.dialog.open(ProfileEditorDialogComponent, {
      width: '400px', // Set the width of the side panel
      height: '100vh', // Full height
      position: {
        top: '0',
        right: '0' // Position on the right
      },
      panelClass: 'profile-editor-panel', // Apply our custom class for animation
      data: { imageUrl: image }
    }).afterClosed().subscribe(result => {
      if (result) {
        let filename = "";
        let imageUrl = "";
        if (result.action === 'remove') {
          // this.imageChanged.emit('remove');
        } else if (result.action === 'upload') {
          filename = result.fileName;
          imageUrl = result.mediaUrl;
          console.log("the media Url is ", imageUrl, "The file name is ", result.filename);
        } else {
          return;
        }


        let object = {
          "entityId": this.leadId,
          "Image": filename
        }

        this.leadService.editLead(object, this.leadId).subscribe(
          (response) => {
            if (response['status_code'] == Constant.RESPONSE_SUCCESS) {
              this.snackBar.open('You added a display picture', '×', { panelClass: 'success', verticalPosition: 'bottom', duration: 500 });
              this.text = "Save";
              this.editMode = false;
              this.getAllLeadDetails(this.leadId);


            } else {
              this.text = "Save";
              this.snackBar.open('Something went wrong on our side. Please try again in a minute.', '×', { panelClass: 'error', verticalPosition: 'bottom', duration: 500 });
            }
            this.loaderService.hide();
          },
          (err) => {
            this.text = "Save";
            this.loaderService.hide();
          });
      }
    });
  }

  deleteAllProductId() {
    this.spinner = true;
    this.textAccount = "Processing";
    this.productService.deleteByLeadId(this.leadId).subscribe(
      response => {
        this.spinner = false;
        if (response['status_code'] == Constant.RESPONSE_SUCCESS) {
          this.snackBar.open(response['status_message'], '×', { panelClass: 'success', verticalPosition: 'bottom', duration: 500 });
          // this.router.navigate([`/lead`])
          this.dialog.closeAll();
        } else {
          this.snackBar.open(response['status_message'], '×', { panelClass: 'error', verticalPosition: 'bottom', duration: 500 });
        }
        this.textAccount = "OK";
      },
      error => {
        this.textAccount = "OK";
        this.spinner = false;
      })

  }

  editProduct() {

    if (this.defaultSetType == 0) {
      this.dialog.closeAll();
      this.router.navigate([`lead/add-edit-lead/${this.leadId}/${this.defaultSet}`])
    } else {
      this.dialog.closeAll();
      this.router.navigate([`lead/add-edit-lead/${this.leadId}/${this.defaultSet}`])
    }
  }


  getAllLeadDetails(leadId) {
    this.leadService.getAllLeadDetailsByEntityId(leadId).subscribe(
      data => {


        if (data['entityId'] != null) {

          this.data = data;

          this.getAllLeadDetailsInitally();

        } else {


          this.snackBar.open('No Data Found!', 'X', {
            duration: 3000,
            verticalPosition: 'bottom',
            panelClass: ['error'],
          });
          this.router.navigate(['lead']);

        }


      },
      error => {

      })
  }

  getAllLeadDetailsInitally() {
    let data = this.data;
    this.getAllCrmData();
    this.getConfigData();
    this.typeYFilter();
    this.getLeadDropDownList();

    this.LeadDetailsObject = data;


    this.uploadedImageUrl = this.basePath + this.LeadDetailsObject.image + this.cid;

    this.updateStars();


    if (this.updateType != 'WalkIn') {
      this.calculateLeadAge();
    }

    this.lifeCycleStage = this.LeadDetailsObject['lifeCycleStage'] || 'Lead';

    this.relatedCompanyId = this.LeadDetailsObject.companyId || 0;

    this.customField1 = this.LeadDetailsObject.customField1 || {};

    this.customField10 = this.LeadDetailsObject.customField10 || {};

    this.customField9 = this.LeadDetailsObject.customField9 || {};

    this.companyId = this.LeadDetailsObject.companyId || 0;

    if (this.LeadDetailsObject?.isCustomizedValue?.Google_Map) {

      this.mapLink = this.LeadDetailsObject?.isCustomizedValue?.Google_Map || '';

    } else {

      this.mapLink = this.LeadDetailsObject?.isCustomizedValue?.GoogleMap || '';

    }



    if (this.LeadDetailsObject.ast != null) {
      const keyValuePairs: [string, any][] = Object.entries(JSON.parse(this.LeadDetailsObject.ast));


      this.type1 = true;
      // const keyValuePairs = JSON.parse(this.LeadDetailsObject.ast);
      this.additionalSpecList = keyValuePairs;
      this.additionalSpec = JSON.parse(this.LeadDetailsObject.ast);
    } else {

      this.additionalSpec = this.LeadDetailsObject.additionalSpec;

    }


    if (this.LeadDetailsObject.valuesString != null) {
      const keyValuePairs: [string, any][] = Object.entries(JSON.parse(this.LeadDetailsObject.valuesString));
      this.type2 = true;
      this.valuesList = keyValuePairs;
      this.filterList = JSON.parse(this.LeadDetailsObject.valuesString);
    } else {
      this.filterList = this.LeadDetailsObject.values;
    }

    if (this.LeadDetailsObject.isCustomizedValueString != null) {
      const keyValuePairs: [string, any][] = Object.entries(JSON.parse(this.LeadDetailsObject.isCustomizedValueString));
      this.type3 = true;
      this.customList = keyValuePairs;
      this.usedInSite = JSON.parse(this.LeadDetailsObject.isCustomizedValueString);
    } else {
      this.usedInSite = this.LeadDetailsObject.isCustomizedValue;
    }

    this.jsonRecieved = this.LeadDetailsObject.jsonRecieved;
    this.ownerId = data['ownerId'];

    this.editformGroup(this.LeadDetailsObject);

    this.leadLoaded = true;
    this.loadCategoriesAndProducts();
    this.resolveCategoryAndProductNames();





  }

  createFile(note: any, noteId: any) {
    const dialogRef = this.dialog.open(FileUploadPopupComponent, {
      width: '80%',
      maxWidth: '1200px',
      height: '100%',
      data: {
        "leadId": this.leadId,
        "note": note,
        "noteId": noteId,
        "type": 1,
        "title": "Attach Document"
      },
      position: { right: '0' },
      panelClass: 'slide-dialog-panel',
      hasBackdrop: true,
      disableClose: true
    });

    dialogRef.afterClosed().subscribe((result) => {
      if (result && result['event'] === 'add') {
        this.getLeadNote(this.leadId);
      }
    });
  }

  deleteNote(value) {
    this.spinner = true;
    this.textAccount = "Processing";
    this.crmNoteService.deleteByNoteId(value.noteId).subscribe(
      response => {
        this.spinner = false;
        if (response['status_code'] == Constant.RESPONSE_SUCCESS) {
          this.snackBar.open(response['status_message'], '×', { panelClass: 'success', verticalPosition: 'bottom', duration: 500 });
          this.getAllLeadDetails(this.leadId);
          this.getLeadNote(this.leadId)

        } else {
          this.snackBar.open(response['status_message'], '×', { panelClass: 'error', verticalPosition: 'bottom', duration: 500 });
        }
        this.textAccount = "OK";
      },
      error => {
        this.textAccount = "OK";
        this.spinner = false;
      })


  }

  downloadNew(value, type) {

    this.downloadImage(value)
  }

  downloadImage(path) {

    this.downloadImageService.downloadImageNew(path);

  }




  updateLeadStatusNew(event, opt) {

    if (event.isUserInput != false) {

      let object = {
        "entityId": this.leadId,
        "LeadStatus": opt.statusId
      }

      this.leadService.editLead(object, this.leadId).subscribe(
        (response) => {
          if (response['status_code'] == Constant.RESPONSE_SUCCESS) {


            this.LeadDetailsObject.statusName = opt.statusId;
            this.currentStatusIndex = this.filtereddropdownTypeList.findIndex(
              s => s.statusName === opt.statusName
            );

            this.LeadDetailsObject.statusName = opt.statusName;
            this.snackBar.open("Status Updated SuccessFully", '×', { panelClass: 'success', verticalPosition: 'bottom', duration: 3000 });
          } else {
            this.snackBar.open(response['status_message'], '×', { panelClass: 'error', verticalPosition: 'bottom', duration: 3000 });
          }
        },
        (err) => {
        });

    }
  }



  openEditPopup(field: string, label: string, type: string) {

    let value = this.LeadDetailsObject[field];

    this.previousValue = value;
    if (label == 'State') {
      value = this.LeadDetailsObject.isCustomizedValue?.State
    }

    if (label === 'Status Name') {
      value = this.LeadDetailsObject.statusId;
    }

    if (label == 'City') {
      value = this.LeadDetailsObject.isCustomizedValue?.City
    }

    if (label == 'Pincode') {
      value = this.LeadDetailsObject.zipCode
    }

    if (label == 'Address') {
      value = this.LeadDetailsObject.additionalSpec?.Address
    }

    if (label == 'Lifecycle stage') {
      value = this.lifeCycleStage;
    }

    const labelLower = (label || '').toLowerCase();

    if (labelLower.includes('category')) {
      value = this.getFieldValue('Category') ?? this.getFieldValue('category') ?? this.LeadDetailsObject?.category ?? this.LeadDetailsObject?.Category;
    }

    if (labelLower.includes('product')) {
      value = this.getFieldValue('Product') ?? this.getFieldValue('product') ?? this.LeadDetailsObject?.product ?? this.LeadDetailsObject?.Product;
    }


    const dialogRef = this.dialog.open(FieldEditDialogComponent, {
      width: '400px',
      height: '214px',
      data: {
        label,
        value: value,
        type,
        element: this.LeadDetailsObject
      },
    });

    dialogRef.afterClosed().subscribe((result) => {
      if (result !== undefined) {
        const saveValue = (result && result.hasOwnProperty('value')) ? result.value : result;
        const displayValue = (result && result.hasOwnProperty('display')) ? result.display : result;
        this.LeadDetailsObject[field] = displayValue;
        console.log('res', field, ':', saveValue, ' (display: ', displayValue, ')');
        this.dynamicSaveLead(this.leadId, field, saveValue, this.LeadDetailsObject);

      }
    });
  }

  dynamicSaveLead(leadId: any, key: string, value: any, element: any) {
    let object: any = {
      entityId: leadId,
    };
    const keyLower = (key || '').toLowerCase();

    if (keyLower === 'lifecycle stage' || keyLower === 'lifecyclestage') {
      object['LifeCycleStage'] = value;
    }

    if (keyLower === 'city') {
      if (this.LeadDetailsObject?.isCustomizedValue) {
        this.LeadDetailsObject.isCustomizedValue.City = value;
        this.LeadDetailsObject.isCustomizedValue.city = value;
      }
      object['City'] = value;
      object['city'] = value;
    }

    if (keyLower === 'pincode' || keyLower === 'zipcode') {
      if (this.LeadDetailsObject?.isCustomizedValue) {
        this.LeadDetailsObject.isCustomizedValue.pincode = value;
      }
      object['pincode'] = value;
      object['Zipcode'] = value;
      object['zipcode'] = value;
    }

    if (keyLower === 'state') {
      if (this.LeadDetailsObject?.isCustomizedValue) {
        this.LeadDetailsObject.isCustomizedValue.State = value;
        this.LeadDetailsObject.isCustomizedValue.state = value;
      }
      object['State'] = value;
      object['state'] = value;
    }

    if (keyLower === 'country') {
      if (!this.LeadDetailsObject.isCustomizedValue) {
        this.LeadDetailsObject.isCustomizedValue = {};
      }
      this.LeadDetailsObject.isCustomizedValue.Country = value;
      this.LeadDetailsObject.isCustomizedValue.country = value;
      this.LeadDetailsObject.country = value;
      this.LeadDetailsObject.Country = value;
      object['Country'] = value;
      object['country'] = value;
    }

    else if (keyLower === 'category') {
      object['Category'] = value;
      object['category'] = value;
    }

    else if (keyLower === 'product') {
      object['Product'] = value;
      object['product'] = value;
      const catVal = this.getFieldValue('Category') ?? this.getFieldValue('category') ?? this.LeadDetailsObject?.Category ?? this.LeadDetailsObject?.category;
      if (catVal != null && catVal !== '') {
        object['Category'] = catVal;
        object['category'] = catVal;
      }
    }

    else if (keyLower === 'statusname' || keyLower === 'leadstatus') {
      object['LeadStatus'] = value;
    }
    else if (keyLower === 'owneremail' || keyLower === 'owner') {
      object['Owner'] = value;
      object['OwnerName'] = element['OwnerName'];
      object['OwnerId'] = element['OwnerId'];
    }
    else if (keyLower === 'company') {
      object['Company'] = element['Company'];
      object['CompanyId'] = element['CompanyId'];
    }
    else if (keyLower === 'tagname' || keyLower === 'tags') {
      object['TagId'] = value;
      object['tagName'] = element['tagName'];
      object['Tags'] = value;
    }
    else {
      object[key] = value;
    }

    if (key === 'email' || key === 'phoneNumber') {
      let payload = {
        Email: key === 'email' ? value : element.email,
        PhoneNumber: key === 'phoneNumber' ? value : element.phoneNumber,
        entityId: leadId
      };

      this.leadService.leadAlreadyExist(payload).subscribe(
        (response) => {
          if (response['status_code'] == Constant.RESPONSE_SUCCESS) {
            this.doSave(object, leadId);
          } else {

            if (key === 'email') {

              this.LeadDetailsObject.email = this.previousValue
            }

            if (key === 'phoneNumber') {
              this.LeadDetailsObject.phoneNumber = this.previousValue
            }

            this.snackBar.open(response['data']['message'], '×', {
              panelClass: 'error',
              verticalPosition: 'bottom',
              duration: 500
            });
          }
        },
        (err) => {

          if (key === 'email') {

            this.LeadDetailsObject.email = this.previousValue
          }

          if (key === 'phoneNumber') {
            this.LeadDetailsObject.phoneNumber = this.previousValue
          }
          this.snackBar.open("Error validating lead", '×', {
            panelClass: 'error',
            verticalPosition: 'bottom',
            duration: 500
          });
        }
      );
    }
    else {
      this.doSave(object, leadId);
    }
  }

  doSave(object: any, leadId: any) {
    this.leadService.editLead(object, leadId).subscribe(
      (response) => {
        if (response['status_code'] == Constant.RESPONSE_SUCCESS) {

          this.getAllLeadDetails(this.leadId)

          this.snackBar.open(response['status_message'] || 'Successfully Updated', '×', {
            panelClass: 'success',
            verticalPosition: 'bottom',
            duration: 3000
          });


        } else {
          this.snackBar.open(response['status_message'] || 'Update failed', '×', {
            panelClass: 'error',
            verticalPosition: 'bottom',
            duration: 3000
          });
        }
      },
      (err) => {
        this.snackBar.open("Save failed", '×', {
          panelClass: 'error',
          verticalPosition: 'bottom',
          duration: 3000
        });
      }
    );
  }

  getAllLeadActivityUpcoming() {


    this.onScrollValueUpcoming = true;

    let search = "a.taskType:*1,* AND a.leadId:*" + this.leadId + ",* AND a.status:*0,*";

    this.activityService.ActivityUpcomingReport(search, 0, 10, 'id,desc', '').subscribe(
      data => {

        this.onScrollValueUpcoming = false;

        this.totalSizeUpcoming = data["totalPages"];

        this.leadActivityListUpcoming = data['content'];

        this.totalUpcoming = data['numberOfElements'];

        this.totalActivityUpComing = data['totalElements']

        this.leadActivityListFinalUpcoming = data;
        this.init = true;

        this.pagetwoUpComing = 0;

      },
      error => {
        this.onScrollValueUpcoming = false;


      })
  }

  onScrollUpcoming() {
    if (this.pagetwoUpcoming < this.totalSizeUpcoming - 1) {
      this.spinner = true;
      this.onScrollValueUpcoming = true;
      this.pagetwoUpcoming++;
      let search = "a.taskType:*1,* AND a.leadId:*" + this.leadId + ",* AND a.status:*0,*";
      this.activityService.ActivityUpcomingReport(search, this.pagetwoUpcoming, 10, 'id,desc', '').subscribe(
        res => {
          if (res['content']?.length) {
            this.leadActivityListUpcoming = [...this.leadActivityListUpcoming, ...res['content']];
          }

          this.totalSizeUpcoming = res["totalPages"];
          this.isEmpty = res["empty"];
          this.onScrollValueUpcoming = this.pagetwo < this.totalSize - 1;
          this.spinner = false;
          this.totalActivityUpComing = res['totalElements']
        },
        error => {
          console.error("Error loading activity:", error);
          this.spinner = false;
          this.onScrollValueUpcoming = false;
        }
      );
    } else {
      this.spinner = false;
      this.onScrollValueUpcoming = false;
    }
  }

  totalDue: any = 0;
  totalActivityDue: any = 0;
  getAllLeadActivityDue() {




    this.onScrollValueDue = true;

    let search = "a.taskType:*1,* AND a.leadId:*" + this.leadId + ",* AND a.status:*0,*";

    this.activityService.searchDynamicLeadReport(search, 0, 10, 'id,desc', '').subscribe(
      data => {

        this.onScrollValueDue = false;

        this.totalSizeDue = data["totalPages"];

        this.leadActivityListDue = data['content'];


        this.totalDue = data['numberOfElements'];

        this.leadActivityListDueFinal = data;

        this.init = true;

        this.pagetwoDue = 0;
        this.totalActivityDue = data['totalElements']




        // console.log(this.leadActivityList);
      },
      error => {
        this.onScrollValueDue = false;


      })
  }

  totalSizeDue: any;
  onScrollUpDue() {
    if (this.pagetwoDue < this.totalSizeDue - 1) {
      this.spinner = true;
      this.onScrollValueUpcoming = true;
      this.pagetwoDue++;
      let search = "a.taskType:*1,* AND a.leadId:*" + this.leadId + ",* AND a.status:*0,*";
      this.activityService.searchDynamicLeadReport(search, this.pagetwoDue, 10, 'id,desc', '').subscribe(
        res => {
          if (res['content']?.length) {
            this.leadActivityListDue = [...this.leadActivityListDue, ...res['content']];
          }

          this.totalSizeDue = res["totalPages"];

          this.totalActivityDue = res['totalElements']
          this.isEmpty = res["empty"];
          this.onScrollValueDue = this.pagetwo < this.totalSize - 1;
          this.spinner = false;
        },
        error => {
          console.error("Error loading activity:", error);
          this.spinner = false;
          this.onScrollValueDue = false;
        }
      );
    } else {
      this.spinner = false;
      this.onScrollValueDue = false;
    }
  }

  onScrollValueCompleted: any = false;
  pagetwoCompleted: any = 0;
  totalActivityCompleted: any = 0;
  getAllLeadActivityCompleted() {



    this.onScrollValueCompleted = true;

    let search = "a.taskType:*1,* AND a.leadId:*" + this.leadId + ",* AND a.status:*1,*";

    this.leadActivityService.searchAllActivity(search, 0, 10, 'id,desc', '').subscribe(
      data => {

        this.onScrollValueCompleted = false;

        this.totalSizeCompleted = data["totalPages"];

        this.leadActivityListCompleted = data['content'];

        this.totalCompleted = data['numberOfElements'];

        this.leadActivityListFinalCompleted = data;

        this.init = true;

        this.pagetwoCompleted = 0;

        this.totalActivityCompleted = data['totalElements']

      },
      error => {
        this.onScrollValueCompleted = false;


      })
  }

  totalSizeCompleted: any;
  onScrollUpCompleted() {
    if (this.pagetwoCompleted < this.totalSizeCompleted - 1) {
      this.spinner = true;
      this.onScrollValueUpcoming = true;
      this.pagetwoCompleted++;
      let search = "a.taskType:*2,* AND a.leadId:*" + this.leadId + ",* AND a.status:*1,*";
      this.leadActivityService.searchAllActivity(search, this.pagetwoCompleted, 10, 'id,desc', '').subscribe(
        res => {
          if (res['content']?.length) {
            this.leadActivityListCompleted = [...this.leadActivityListCompleted,
            ...res['content']];
          }

          this.totalSizeCompleted = res["totalPages"];
          this.isEmpty = res["empty"];
          this.onScrollValueCompleted = this.pagetwoCompleted < this.totalSizeCompleted - 1;
          this.spinner = false;
          this.totalActivityCompleted = res['totalElements']
        },
        error => {

          this.spinner = false;
          this.onScrollValueCompleted = false;
        }
      );
    } else {
      this.spinner = false;
      this.onScrollValueCompleted = false;
    }
  }


  toggleEditMenu(event: Event) {
    event.stopPropagation(); // Prevent unwanted clicks closing the menu
    this.isEditMenuOpen = !this.isEditMenuOpen;
  }

  saveEdit() {

    this.isEditMenuOpen = false; // Close menu after saving
  }
  loadingSpinner = true;
  generateTooltip(step: any) {
    return `Lead Status Name : ${step.statusName}`;
  }
  gotoLeadDetailPage() {
    this.dialogRef.close()
    this.router.navigate([`leadDetail/${this.leadId}`])


  }
  showToContactDetials() {
    this.setActiveTab("Contact details")
  }
  updateLeadStatus(step: any) {
    if (this.LeadDetailsObject.statusName === step.statusName) {
      return;
    }

    // Update the form’s LeadStatus to the clicked step
    this.firstFormGroup.patchValue({
      LeadStatus: step.statusId
    });

    this.LeadDetailsObject.statusName = step.statusId;
    this.currentStatusIndex = this.filtereddropdownTypeList.findIndex(
      s => s.statusName === step.statusName
    );

    // Save to backend using your existing function
    this.saveLead();
  }

  setActiveTab(tabName: string): void {
    this.activeTab = tabName;
    const scrollToTop = () => {
      try {
        window.scrollTo({ top: 0, behavior: 'auto' });
        const scrollContainers = document.querySelectorAll('.content, .right-content-area, .dynamic-content, mat-sidenav-content');
        scrollContainers.forEach(container => {
          const originalScrollBehavior = (container as HTMLElement).style.scrollBehavior;
          (container as HTMLElement).style.scrollBehavior = 'auto';
          container.scrollTop = 0;
          (container as HTMLElement).style.scrollBehavior = originalScrollBehavior;
        });
      } catch (e) {
        console.error('Error scrolling to top:', e);
      }
    };
    scrollToTop();
    setTimeout(scrollToTop, 0);
  }


  openPopup(note?: any): void {
    if (note) {
      // EDIT MODE
      this.isEditing = true;
      // Create a copy to avoid modifying the original object directly
      this.currentNoteData = { ...note };
    } else {
      // CREATE MODE
      this.isEditing = false;
      this.currentNoteData = { notes: '', documentType: 0 };
    }
    this.isPopupVisible = true;
  }

  closePopup(): void {
    this.isPopupVisible = false;
  }
  saveNote(): void {
    if (this.isEditing) {

      this.createNote(this.currentNoteData as any, this.currentNoteData.noteId!);
    } else {

      this.createNote(null, 0);
    }
    this.closePopup();
  }
  toggleShowMore(noteId: number): void {
    if (this.expandedNotes.has(noteId)) {
      this.expandedNotes.delete(noteId);
    } else {
      this.expandedNotes.add(noteId);
    }
  }

  isExpanded(noteId: number): boolean {
    return this.expandedNotes.has(noteId);
  }

  saveField(field: any) {
    this.loading = true;

    // Simulating API call or saving logic
    setTimeout(() => {
      this.loading = false;
      this.editMode = null; // Exit edit mode after saving
    }, 2000); // Simulating delay
  }
  toggleSection(section: any): void {
    section.isOpen = !section.isOpen;
  }

  toggleCollapse() {
    this.isCollapsed = !this.isCollapsed;
  }

  openEditMenu(field: any, event: MouseEvent) {
    this.selectedField = field;
    event.stopPropagation();
  }

  editField(field: any, option: string) {

  }
  copyEmail() {
    const email = document.querySelector(".details-email-container").firstChild.textContent.trim();
    navigator.clipboard.writeText(email).then(() => {
      alert("Copied to clipboard: " + email);
    }).catch(err => {

    });
  }


  setViewNew(view: 'Original' | 'basic'): void {
    this.activeViewNew = view;
  }


  goToCompany() {



    if (this.LeadDetailsObject.companyId == 0 || this.LeadDetailsObject.companyId == null) {
      this.snackBar.open('No Company Associated', '×', { panelClass: 'error', verticalPosition: 'bottom', duration: 500 });
      return;
    }
    this.dialogRef.close();
    this.router.navigate([`companiesDetail/${this.LeadDetailsObject.companyId}`])
  }


  phoneNumbercallSecondary(data) {

    data['phoneNumber'] = data.secondaryphoneno;

    if (this.dialerType == 1) {
      this.leadActivityService.makeCall(data).subscribe(
        response => {
          if (response['status_code'] == Constant.RESPONSE_SUCCESS) {
            this.snackBar.open(response['status_message'], '×', { panelClass: 'success', verticalPosition: 'bottom', duration: 300 });
            this.dialog.closeAll();
          } else {
            this.snackBar.open(response['status_message'], '×', { panelClass: 'error', verticalPosition: 'bottom', duration: 300 });
          }
          this.dialog.closeAll();
        },
        error => {

        });
    }
    else if (this.dialerType == 2) {
      this.opendialCallsa(data)
      this.callANumber1(data, data.phoneNumber)
    }

    else if (this.dialerType == 3) {
      this.loaderService.show();
      this.leadActivityService.makeDooctiClickToCall(data).subscribe(
        response => {
          if (response['status_code'] == Constant.RESPONSE_SUCCESS) {
            this.snackBar.open(response['status_message'], '×', { panelClass: 'success', verticalPosition: 'bottom', duration: 300 });


          } else {
            this.snackBar.open(response['status_message'], '×', { panelClass: 'error', verticalPosition: 'bottom', duration: 300 });
          }
          this.loaderService.hide();

        },
        error => {
          this.loaderService.hide();
        });

    }
    else if (this.dialerType == 5) {
      this.loaderService.show();
      this.leadActivityService.makeTelecmi(data).subscribe(
        response => {
          if (response['status_code'] == Constant.RESPONSE_SUCCESS) {
            this.snackBar.open(response['status_message'], '×', { panelClass: 'success', verticalPosition: 'bottom', duration: 300 });


          } else {
            this.snackBar.open(response['status_message'], '×', { panelClass: 'error', verticalPosition: 'bottom', duration: 300 });
          }
          this.loaderService.hide();

        },
        error => {
          this.loaderService.hide();
        });

    }
    else if (this.dialerType == 6) {
      this.loaderService.show();
      this.leadActivityService.clickToCallAcefone(data).subscribe(
        response => {
          if (response['status_code'] == Constant.RESPONSE_SUCCESS) {
            this.snackBar.open(response['status_message'], '×', { panelClass: 'success', verticalPosition: 'bottom', duration: 300 });


          } else {
            this.snackBar.open(response['status_message'], '×', { panelClass: 'error', verticalPosition: 'bottom', duration: 300 });
          }
          this.loaderService.hide();

        },
        error => {
          this.loaderService.hide();
        });

    }
    else {

      this.loaderService.hide();

      let phonenumber;

      if (data.phoneNumber.startsWith("91")) {
        phonenumber = "+" + data.phoneNumber;
      }
      else {
        phonenumber = data.phoneNumber;
      }


      window.location.href = "tel:" + phonenumber;

    }
  }


  manageFields() {
    this.dialogRef.close();
    this.router.navigate([`/fieldDesigner/${this.leadId}`])
  }

  manageFieldsList: any;

  getAllManageContactFields() {
    this.fieldDesignerService.getAllContactFieldsDropDown()
      .subscribe(
        res => {
          this.manageFieldsList = res;
          this.mapFieldsWithValues();

        },
        error => {
        })
  }



  openEditPopupNew(fieldKey: string, label: string, type: string, fieldRef: any) {
    const normKey = this.normalizeKey(fieldKey);
    if (['notes', 'note'].includes(normKey)) {
      return;
    }

    if (fieldKey && fieldKey.toLowerCase().includes('owner')) {
      this.transferLead();
      return;
    }

    let value = this.resolveFieldValue(fieldKey);

    if (
      ['leadstatus', 'leadsource']
        .includes(this.normalizeKey(fieldKey)) &&
      value !== null &&
      value !== undefined &&
      !isNaN(Number(value))
    ) {
      value = Number(value);
    }


    this.previousValue = value;

    const dialogRef = this.dialog.open(FieldEditDialogComponent, {
      width: '400px',
      height: '214px',
      data: {
        label,
        value,
        type,
        element: this.LeadDetailsObject,
        fieldRef,
        optionValues: fieldRef.optionValues,
        optionId: fieldRef.optionId,
        isRequired: fieldRef.isRequired
      },
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result === undefined) return;

      const saveValue = (result && typeof result === 'object' && result.hasOwnProperty('value')) ? result.value : result;
      const displayValue = this.getDisplayValue(fieldKey, (result && typeof result === 'object' && result.hasOwnProperty('display')) ? result.display : saveValue);

      fieldRef.rawValue = saveValue;
      fieldRef.value = displayValue;


      this.patchResolvedValue(fieldKey, displayValue);

      this.dynamicSaveLead(
        this.leadId,
        fieldKey,
        saveValue,
        this.LeadDetailsObject
      );
    });
  }

  patchResolvedValue(fieldKey: string, value: any) {
    const normalized = this.normalizeKey(fieldKey);

    if (normalized === 'category') {
      this.LeadDetailsObject.category = value;
      this.LeadDetailsObject.Category = value;
    }
    if (normalized === 'product') {
      this.LeadDetailsObject.product = value;
      this.LeadDetailsObject.Product = value;
    }

    const targets = [
      this.LeadDetailsObject,
      this.LeadDetailsObject.values,
      this.LeadDetailsObject.additionalSpec,
      this.LeadDetailsObject.isCustomizedValue,
      this.patchValues
    ];

    for (const target of targets) {
      if (!target) continue;

      for (const key of Object.keys(target)) {
        if (this.normalizeKey(key) === normalized) {
          target[key] = value;
        }
      }
    }
  }


  resolveFieldValue(fieldKey: string): any {
    if (!this.LeadDetailsObject) return null;

    const normalized = this.normalizeKey(fieldKey);
    const isCategoryOrProduct = normalized === 'category' || normalized === 'product';

    const nested = [
      this.LeadDetailsObject.values,
      this.LeadDetailsObject.additionalSpec,
      this.LeadDetailsObject.isCustomizedValue,
      this.LeadDetailsObject.jsonRecieved
    ];

    const sources = isCategoryOrProduct
      ? [...nested, this.LeadDetailsObject]
      : [this.LeadDetailsObject, ...nested];

    for (const source of sources) {
      if (!source) continue;

      for (const key of Object.keys(source)) {
        if (this.normalizeKey(key) === normalized) {
          const val = source[key];
          if (val !== null && val !== undefined && String(val).trim() !== '') {
            return val;
          }
        }
      }
    }

    return null;
  }


  categoryList: any[] = [];
  productList: any[] = [];

  loadCategoriesAndProducts() {
    if (this.categoriesService) {
      this.categoriesService.getAllCategories(0, 1000, 'id,desc').subscribe(
        (res: any) => {
          this.categoryList = res['content'] || res || [];
          this.resolveCategoryAndProductNames();
        },
        () => { }
      );
    }
    if (this.productService) {
      this.productService.getProductByType(0, 500, 'id,desc', '').subscribe(
        (res: any) => {
          this.productList = res['content'] || res || [];
          this.resolveCategoryAndProductNames();
        },
        () => { }
      );
    }
  }

  resolveCategoryAndProductNames() {
    if (!this.LeadDetailsObject) return;

    const rawCat = this.getFieldValue('Category') ?? this.getFieldValue('category') ?? this.LeadDetailsObject?.category ?? this.LeadDetailsObject?.Category;
    if (rawCat != null && String(rawCat).trim() !== '') {
      const valStr = String(rawCat).trim().toLowerCase();
      const matchCat = this.categoryList.find((c: any) =>
        String(c.id ?? c.categoryId ?? '').toLowerCase() === valStr ||
        String(c.name ?? c.categoryName ?? '').trim().toLowerCase() === valStr
      );
      if (matchCat) {
        const catName = matchCat.name ?? matchCat.categoryName;
        this.LeadDetailsObject.category = catName;
        this.LeadDetailsObject.Category = catName;
      } else if (isNaN(Number(rawCat))) {
        this.LeadDetailsObject.category = rawCat;
        this.LeadDetailsObject.Category = rawCat;
      }
    }

    const rawProd = this.getFieldValue('Product') ?? this.getFieldValue('product') ?? this.LeadDetailsObject?.product ?? this.LeadDetailsObject?.Product;
    if (rawProd != null && String(rawProd).trim() !== '') {
      const valStr = String(rawProd).trim().toLowerCase();
      const matchProd = this.productList.find((p: any) =>
        String(p.id ?? p.entityId ?? p.productId ?? '').toLowerCase() === valStr ||
        String(p.name ?? '').trim().toLowerCase() === valStr
      );
      if (matchProd) {
        this.LeadDetailsObject.product = matchProd.name;
        this.LeadDetailsObject.Product = matchProd.name;
      } else if (isNaN(Number(rawProd))) {
        this.LeadDetailsObject.product = rawProd;
        this.LeadDetailsObject.Product = rawProd;
      }
    }

    this.mapFieldsWithValues();
    if (this.changeDetector) {
      this.changeDetector.markForCheck();
    }
  }

  resolveNameFromList(type: string, rawValue: any): string | null {
    if (rawValue == null || String(rawValue).trim() === '') return null;
    const valStr = String(rawValue).trim().toLowerCase();
    if (type === 'category') {
      const match = this.categoryList.find((c: any) =>
        String(c.id ?? c.categoryId ?? '').toLowerCase() === valStr ||
        String(c.name ?? c.categoryName ?? '').trim().toLowerCase() === valStr
      );
      return match ? (match.name ?? match.categoryName) : null;
    }
    if (type === 'product') {
      const match = this.productList.find((p: any) =>
        String(p.id ?? p.entityId ?? p.productId ?? '').toLowerCase() === valStr ||
        String(p.name ?? '').trim().toLowerCase() === valStr
      );
      return match ? match.name : null;
    }
    return null;
  }

  mappedGroups: any[] = [];


  mapFieldsWithValues() {
    if (!this.manageFieldsList || !this.LeadDetailsObject) return;

    this.mappedGroups = this.manageFieldsList
      .filter(group => group.isActive === 1)
      .map(group => ({
        groupName: group.groupName,
        fields: group.contactFields
          .filter(field => field.isActive === 1)
          .map(field => {
            const rawValue = this.getFieldValue(field.fieldKey);
            const norm = this.normalizeKey(field.fieldKey);

            const readOnlyFields = ['opendealamount', 'opendealsamount', 'wondealamount', 'score', 'notes', 'note'];
            let isReadOnly = field.isReadOnly;
            if (readOnlyFields.includes(norm)) {
              isReadOnly = true;
            }

            return {
              fieldId: field.fieldId,
              fieldName: field.fieldName,
              fieldKey: field.fieldKey,
              fieldType: field.fieldType,
              isReadOnly: isReadOnly,
              rawValue,
              value: this.getDisplayValue(field.fieldKey, rawValue)
            };
          })
      }));
  }

  getDisplayValue(fieldKey: string, rawValue: any): any {
    if (!this.LeadDetailsObject) return rawValue;

    switch (this.normalizeKey(fieldKey)) {

      case 'leadstatus':
        return this.LeadDetailsObject.statusName ?? rawValue;

      case 'leadsource':
        return this.LeadDetailsObject.sourceName ?? rawValue;

      case 'category':
        return this.LeadDetailsObject?.category ?? this.LeadDetailsObject?.Category ?? this.resolveNameFromList('category', rawValue) ?? rawValue;

      case 'product':
        return this.LeadDetailsObject?.product ?? this.LeadDetailsObject?.Product ?? this.resolveNameFromList('product', rawValue) ?? rawValue;

      default:
        return rawValue;
    }
  }

  getFieldValue(fieldKey: string): any {
    if (!this.LeadDetailsObject) return null;

    const normalized = this.normalizeKey(fieldKey);

    // For category and product: check nested EAV sources first to get the numeric ID,
    // not the stale text name that may be stored in the root object.
    const isCategoryOrProduct = normalized === 'category' || normalized === 'product';

    const nestedSources = [
      this.LeadDetailsObject.values,
      this.LeadDetailsObject.additionalSpec,
      this.LeadDetailsObject.isCustomizedValue,
      this.LeadDetailsObject.jsonRecieved,
      this.LeadDetailsObject.customField1,
      this.LeadDetailsObject.customField2,
      this.LeadDetailsObject.customField3,
      this.LeadDetailsObject.customField4,
      this.LeadDetailsObject.customField5,
      this.LeadDetailsObject.customField6,
      this.LeadDetailsObject.customField7,
      this.LeadDetailsObject.customField8,
      this.LeadDetailsObject.customField9,
      this.LeadDetailsObject.customField10
    ];

    const sources = isCategoryOrProduct
      ? [...nestedSources, this.LeadDetailsObject]
      : [this.LeadDetailsObject, ...nestedSources];

    for (const source of sources) {
      if (!source) continue;

      for (const key of Object.keys(source)) {
        if (this.normalizeKey(key) === normalized) {
          const val = source[key];
          if (val !== null && val !== undefined && String(val).trim() !== '') {
            return val;
          }
        }
      }
    }

    return null;
  }


  private normalizeKey(key: string): string {
    if (!key) return '';
    let norm = key
      .toLowerCase()
      .replace(/\s+/g, '')
      .replace(/_/g, '');

    if (['productenquired', 'productenquiry', 'posproducts', 'posproduct', 'posproductsname'].includes(norm)) {
      return 'product';
    }

    if (['categoryname', 'poscategory', 'poscategories'].includes(norm)) {
      return 'category';
    }

    return norm;
  }




  sanitizeUrl(u: string): string {
    return (u || '')
      .replace(/^\/+/, '')
      .replace(/[?#&=]/g, '-')
      .replace(/[^a-zA-Z0-9_-]+/g, '-')
      .replace(/-+/g, '-')
      .replace(/^-|-$/g, '')
      .toLowerCase();
  }

  ngOnDestroy() {
    this._onDestroy.next();
    this._onDestroy.complete();
  }

  onScrollNew() {
    if (this.pagetwo < this.totalSize - 1) {
      this.spinner = true;
      this.onScrollValue = false; // prevent multiple triggers

      this.pagetwo++;

      this.leadActivityService
        .getAllLeadActivityByPageableNew(this.pagetwo, 10, 'id,desc', this.leadId, "1")
        .subscribe(
          res => {
            if (res['content']?.length) {
              this.leadActivityList = [...this.leadActivityList, ...res['content']];
              this.processActivities(); // regroup and update groupedActivities
            }

            this.totalSize = res["totalPages"];
            this.onScrollValue = this.pagetwo < this.totalSize - 1;
            this.spinner = false;
          },
          error => {
            console.error("Error loading more activities:", error);
            this.spinner = false;
            this.onScrollValue = false;
          }
        );
    }
  }
}
